import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EvsProductService } from '../../../../../common/services/EvsProduct.service';
import { ImageService } from '../../../../imageService';
import { AuthBusinessService } from '../../../../../common/services/AuthBusiness.service';
import { BoxStampDistributionService } from './services/boxStampDistribution.service';
import { Subject } from 'rxjs/Subject';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { environment } from '../../../../../../environments/environment';
import { UploadService } from '../../../../../common/services/Upload.service';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap';
import * as _ from 'lodash';
import { type } from 'os';
import { TranslateService } from '@ngx-translate/core';

declare function baseTracking(appId);

declare function visibleContent(regionName: any, contentName: any, index: any);

declare function clickTracking(regionName: any, contentName: any, target: any, payload: any);

declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-boxStampDistribution',
  templateUrl: './boxStampDistribution.component.html',
  styles: [``],
  styleUrls: ['./boxStampDistribution.component.css'],
  providers: [
    EvsProductService,
    ImageService,
    AuthBusinessService,
    BoxStampDistributionService,
    BsModalService,
    ModalDirective
  ],
})
export class BoxStampDistributionComponent implements OnInit, OnDestroy {
  @Output('hideCrating') hideCrating = new EventEmitter();
  @Output('hideDistribution') hideDistribution = new EventEmitter();
  @ViewChild('select2Api') select2Api;
  @ViewChild('boxRetalStamps') boxRetalStamps;
  @ViewChild('searchBatchStamp') searchBatchStamp;
  @Output() loadDataParent = new EventEmitter();
  @Output() hideComponent = new EventEmitter();
  @ViewChild('campaign') public campaign: ModalDirective;
  @ViewChild('scan') scan: ModalDirective;
  @ViewChild('confirm') confirm: ModalDirective;
  @ViewChild('program') program;
  @ViewChild('singleStamp') singleStamp;
  @ViewChild('campaignSellout') campaignSellout;
  @ViewChild('campaignLoyalty') campaignLoyalty;
  @ViewChild('campaignsSellout') campaignsSellout: ModalDirective;
  @ViewChild('campaignsLoyalty') campaignsLoyalty: ModalDirective;
  @Input() dataStampHistoryActive: any;
  z;
  modalRef: BsModalRef;
  // @ViewChild('itemProduct') itemProduct;
  step = 1;
  title = 'PHÂN PHỐI TEM';
  activeTab = 1;
  no_product = 'assets/images/no_product.png';
  no_image = 'assets/images/no-image.png';
  addContent = '';
  internalCodeContent = '';
  addContentStampList = '';
  listContent = [];
  internalCodes: string[] = [];
  successInternalCodes: string[] = []; // Lưu các internalCodes đã thành công
  listContentStampCodeList = [];
  // listContentProduct = [];
  agencyArea = [];
  districtForAgencyArea = [];
  is_districtForAgencyArea = false;
  dataSelect;
  public message: { class: string; content: string } = null;
  public titleFile = 'Chọn file upload';
  public files: any = null;
  public files2: any;
  public data_import_success: { class: string; content: string; } = null;
  public data_import_fail: { class: string; content: string; } = null;
  stampList = [];
  stampListCodeList = [];
  errorMessage = [];
  public user: any;
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public citiesAgency: Array<any> = [];
  public districtsAgency: Array<any> = [];
  public distributionAgent: Array<any> = [];
  unsubscribe$ = new Subject<void>();
  // totalStatus;
  groupItems = [];
  dataAgent = [];
  // fakeData;
  // realData = '';
  // waringListContent = '';
  formCratingBatch: FormGroup = this.fb.group({
    // is_cratingStampsList: [false],
    // is_cratingProductSingle: [false],
    // is_cratingProductList: [false],
    // is_apply: [false],
    is_cratingStamps: ['cratingStampBoxProduct'],
    addressAgent: [''],
    is_request: [],
    is_request_import: [],
    is_routing: [false],
    stampCode: ['', [Validators.required]],
    // stampCodeList: this.fb.array([]),
    stampCodeProductList: this.fb.array([]),
    name: [''],
    note: [''],
    is_routingTypeDistribution: [''],
    is_routingImportTypeDistribution: ['routingImport'],
    stampCodeList: this.fb.group({
      prefixStampList: ['', [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      serialFirstStampList: ['', [Validators.required]],
      serialLastStampList: ['', [Validators.required]],
    })
  });

  showCityAgent: boolean;
  showDistrictAgent: boolean;
  addressAgent;
  show_cancel_button = false;
  hiddenFMC = false;
  listImageDistribution: any = [];
  /**[31-10-2021]- Tuanba: Tối ưu khư vực đại lý **/
  public listLocationNew = [];
  public isLocationItem: any;
  district_modal_new = []
  public citiesNews = [];

  public listLocationNewTab2 = [];
  public isLocationItemTab2: any = 0;
  district_modal_new_tab2 = []
  public citiesNewsTab2 = [];
  public detailAgencyLocation: any;
  public checkPrefixData = [];
  public totalCheckPrefixData: any;
  public showCityDistrictNew: any;
  public listStampHistoryActive = {
    routing: true,
    group: { items: [] },
    type: null,
    internalCode: false,
    internalCodes: []
  };
  public listStampsHistoryActive = {
    routing: true,
    group: { items: [] },
    type: null,
    internalCode: false,
    internalCodes: []
  };
  timeout: any = null;
  checkboxSigle: false
  internalCode = false
  // Tuanba thêm màn phân phối tem sp và tem thùng
  checkboxBoxProductStamp: false
  checkboxList: false
  firstTemp = ''
  lastTemp = ''
  has_data_campaign = true;
  errorMessageSellout = '';
  public pageIndex = 1;
  public page_size = 6;
  public totalRow = 0;
  public total_data_campaign = 0
  listOfChecked = '';
  // End Select search
  checkSelectCampain = 0;
  activeTab2 = 1;
  errMessageValidate = [];
  has_data_campaign_loyalty = true;
  disableSubmitFormConfirm = false;
  errorMessageLoyalty = '';
  public pageIndex_loyalty = 1;
  public page_size_loyalty = 6;
  public totalRow_loyalty = 0;
  public total_data_campaign_loyalty = 0
  listOfCheckedLoyalty = '';
  checkSelectCampainLoyalty = 0;
  // }
  errorMessageStamSingle = [];
  isLoading = false;
  data_campaign = []
  public pager: any;
  list_id = [];
  // codeList
  myCampaign = {}
  isCampaign = false;
  public campaignCode: string;
  public codeCampaignSellout: any;
  public verifyCampaignSellout: any;
  public isActiveCampaignSellout: boolean;
  public isActiveCampaignLoyalty: boolean;
  // end codeList
  /** Gán chương trình loyalty */
  data_campaign_loyalty = []
  public pager_lotalty: any;
  public applyScan: any;
  public priority: any;
  list_idLoyalty = [];
  myCampaignLoyalty = {}
  isCampaignLoyalty = false;
  public campaignCodeLoyalty: string;
  public giftCode: string;
  public changeService: any = 0;
  public changeIdetification: Boolean = false;
  public changeOverflow: Boolean = false;
  public codeCampaignLoyalty: any;
  public verifyCampaignLoyalty: any;

  distriButionAgencyTextStep3: any;
  distriButionLocationStep3 = [];
  public errorStampCodeListInput = '';
  public isCheckRouting = true;
  public isCheckRoutingImport = true;
  public errorCodeListStamp = []
  public successCodeListStamp = []
  errorListStampSingle: any;
  public number_stamp_success: any = 0;
  public number_stamp_fail: any = 0;
  public errorListStamp = []
  public successListStamp = []
  public typeStampModalString = '';
  public typeStampModal = ''
  public msgStampModal = ''
  public max_quantity: any;
  public countStampSuccess: any = 0;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    public addressService: EvsAddressService,
    private boxStampDistributionService: BoxStampDistributionService,
    private upload: UploadService,
    private imageService: ImageService,
    private modalService: BsModalService,
    private translateService: TranslateService,
  ) {
    this.user = JSON.parse(localStorage.getItem('User'));
  }


  initTranslations() {
    this.title = this.translateService.instant('PHAN_PHOI_TEM');
    this.titleFile = this.translateService.instant('CHON_FILE_UPLOAD');
    this.initSelect2();
  }

  initSelect2() {
    const timKiemLoTem = this.translateService.instant('TIM_KIEM_LO_TEM');
    const chonPrefix = this.translateService.instant('CHON_PREFIX');
    const tinhThanh = this.translateService.instant('TINH_THANH');
    const quanHuyen = this.translateService.instant('QUAN_HUYEN');
    const chonTinhThanh = this.translateService.instant('CHON_TINH_THANH_1');
    const chonQuanHuyen = this.translateService.instant('CHON_QUAN_HUYEN_1');
    const chonQuanHuyen1 = this.translateService.instant('CHON_QUAN_HUYEN_1');
    const daiLyPhanPhoi = this.translateService.instant('DAI_LY_PHAN_PHOI');
    const chonDaiLy = this.translateService.instant('CHON_AI_LY_PHAN_PHOI_1');

    if ($('#searchBatchStamp').data('select2')) {
      $('#searchBatchStamp').select2('destroy');
    }
    $('#searchBatchStamp').select2({
      placeholder: timKiemLoTem,
      allowClear: true
    });

    if ($('#prefixStampList').data('select2')) {
      $('#prefixStampList').select2('destroy');
    }
    $('#prefixStampList').select2({
      placeholder: chonPrefix,
      allowClear: true
    });

    if ($('#city').data('select2')) {
      $('#city').select2('destroy');
    }
    $('#city').select2({
      placeholder: tinhThanh,
      allowClear: true
    });

    if ($('#district').data('select2')) {
      $('#district').select2('destroy');
    }
    $('#district').select2({
      placeholder: quanHuyen,
      allowClear: true
    });

    if ($('#cityAgency').data('select2')) {
      $('#cityAgency').select2('destroy');
    }
    $('#cityAgency').select2({
      placeholder: chonTinhThanh,
      allowClear: true
    });

    if ($('#districtAgency').data('select2')) {
      $('#districtAgency').select2('destroy');
    }
    $('#districtAgency').select2({
      placeholder: chonQuanHuyen,
      allowClear: true
    });

    if ($('#cityAgency1').data('select2')) {
      $('#cityAgency1').select2('destroy');
    }
    $('#cityAgency1').select2({
      placeholder: chonTinhThanh,
      allowClear: true
    });

    if ($('#districtAgency1').data('select2')) {
      $('#districtAgency1').select2('destroy');
    }
    $('#districtAgency1').select2({
      placeholder: chonQuanHuyen1,
      allowClear: true
    });

    if ($('#distributionAgent').data('select2')) {
      $('#distributionAgent').select2('destroy');
    }
    $('#distributionAgent').select2({
      placeholder: daiLyPhanPhoi,
      allowClear: true
    });

    if ($('#cityStep2').data('select2')) {
      $('#cityStep2').select2('destroy');
    }
    $('#cityStep2').select2({
      placeholder: chonTinhThanh,
      allowClear: true
    });

    if ($('#districtStep2').data('select2')) {
      $('#districtStep2').select2('destroy');
    }
    $('#districtStep2').select2({
      placeholder: chonQuanHuyen,
      allowClear: true
    });

    $('.distributionAgent1').select2({
      placeholder: chonDaiLy,
      allowClear: true,
    });
    $('.cityAgent').select2({
      placeholder: chonTinhThanh,
      allowClear: true,
    });
    $('.districtAgent').select2({
      placeholder: chonQuanHuyen,
      allowClear: true,
    });
    $('.slt-batchstamp').select2({
      placeholder: this.translateService.instant('LO_TEM_PLACEHOLDER'),
      allowClear: true,
    });
  }

  ngOnDestroy() {
    this.reset(this.formCratingBatch.value.is_cratingStamps)
    this.step = 1;
  }

  onChange(event) {
    console.log('event', event)
    this.files = event.target.files;
    this.files2 = this.files[0];
    if (this.files.length > 0) {
      this.titleFile = this.files[0].name;
    } else {
      this.titleFile = 'Chọn file upload';
    }
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  changeCheckboxList() {
    this.checkboxList = $('#checkboxList').is(':checked')
    setTimeout(() => {
      $('#checkboxListF').focus()
    }, 500)
  }

  changeCheckboxListValue(type) {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    let checkboxListVal: any;
    if (type === 'first') {
      // let tmp = $('#checkboxSigleVal').val()
      // tmp = tmp[0].toLowerCase() + tmp.slice(1)
      let checkboxListFscan = $('#checkboxListF').val('')
      checkboxListFscan = checkboxListFscan[0] + checkboxListFscan.slice(1)
      checkboxListVal = checkboxListFscan
    } else {
      let checkboxListLscan = $('#checkboxListL').val('');
      checkboxListLscan = checkboxListLscan[0] + checkboxListLscan.slice(1)
      checkboxListVal = checkboxListLscan
    }
    this.timeout = setTimeout(() => {
      let id = '';
      if (checkboxListVal.search('http') !== -1 || checkboxListVal.search('http') !== -1) {
        const splitLink = checkboxListVal.split('/')
        id = splitLink[splitLink.length - 1]
      } else {
        id = checkboxListVal
      }
      if (id) {
        console.log('id', id)
        this.boxStampDistributionService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              if (type === 'first') {
                this.firstTemp = Array.isArray(val.data) ? val.data[0] : val.data;
                $('#checkboxListL').focus()
              } else {
                // clear all
                this.lastTemp = Array.isArray(val.data) ? val.data[0] : val.data;
                if (this.firstTemp.split('-')[0] === this.lastTemp.split('-')[0]) {
                  // tslint:disable-next-line:max-line-length
                  // this.codeList().push(this.newCodeListScan(this.firstTemp.split('-')[0], this.firstTemp.split('-')[1], this.lastTemp.split('-')[1]));
                  // this.stampCodeChanged(this.formCratingBatch.value.stampCodeList.length - 1)
                  const stamp = {
                    prefix: this.firstTemp.split('-')[0],
                    idStart: this.firstTemp.split('-')[1],
                    idEnd: this.lastTemp.split('-')[1]
                  }
                  console.log('sadasdasdasd', stamp)
                  const totalStamp = this.successListStamp.length + this.successCodeListStamp.length;
                  const maxSize = this.max_quantity;
                  const maxStampInput = maxSize - totalStamp
                  console.log('totalStamp', totalStamp)
                  if (totalStamp >= maxSize) {
                    $('#warningStamp').modal('show');
                    return;
                  }
                  if ((maxSize - totalStamp) <= 0) {
                    $('#warningStamp').modal('show');
                    return;
                  } else {
                    if (maxStampInput >= 0) {
                      this.addStampCodeList('scan', stamp)
                    }
                  }
                  $('#checkboxListF').val('')
                  $('#checkboxListL').val('')
                  $('#checkboxListF').focus()

                } else {
                  this.toastr.warning(this.translateService.instant('SERIAL_CUOI_KHONG_HOP_LE'), this.translateService.instant('CANH_BAO'), {
                    timeOut: 3000,
                    positionClass: 'toast-top-right',
                  });
                  $('#checkboxListL').val('')
                }
              }
              // this.loadDataChild([val.data])
            } else {
              this.toastr.warning(this.translateService.instant('TEM_KHONG_HOP_LE'), this.translateService.instant('CANH_BAO'), {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning(this.translateService.instant('TEM_KHONG_HOP_LE'), this.translateService.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    }, 50);
  }

  newCodeListScan(prefix, serialFirst, serialLast): FormGroup {
    return this.fb.group({
      prefix: prefix,
      serialFirst: serialFirst,
      serialLast: serialLast,
      data: [],
      mess: '',
    });
  }

  changeCheckboxSigle() {
    this.checkboxSigle = $('#checkboxSigle').is(':checked')
    setTimeout(() => {
      $('#checkboxSigleVal').focus()
    }, 100)
  }

  toggleInternalCode(event) {
    const target = event && event.target;
    const checked = target && typeof target.checked === 'boolean' ? target.checked : false;
    this.internalCode = checked;
    this.listStampHistoryActive.internalCode = this.internalCode;
    this.listStampsHistoryActive.internalCode = this.internalCode;
  }

  addInternalCodes() {
    const codes = (this.internalCodeContent || '').split('\n')
      .map((code) => code.trim())
      .filter((code) => code);
    if (!codes.length) {
      return;
    }
    console.log('successListStamp', this.successListStamp)
    console.log('codes', codes)
    console.log('successInternalCodes', this.successInternalCodes)

    // Lọc bỏ các codes đã thành công trước đó
    const filteredCodes = codes.filter(code => !this.successInternalCodes.includes(code));

    if (filteredCodes.length === 0) {
      this.toastr.warning(this.translateService.instant('TAT_CA_TEM_DA_DUOC_THEM'), this.translateService.instant('THONG_BAO_1'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      this.internalCodeContent = '';
      return;
    }

    if (filteredCodes.length < codes.length) {
      const removedCount = codes.length - filteredCodes.length;
      this.toastr.info(`${removedCount} ` + this.translateService.instant('TEM_DA_DUOC_THEM_TRUOC_DO_DA_LOAI_BO'), this.translateService.instant('THONG_BAO_1'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
    }

    this.internalCodes = filteredCodes;
    this.listStampHistoryActive.internalCodes = [...this.internalCodes];
    this.listStampsHistoryActive.internalCodes = [...this.internalCodes];
    this.internalCodeContent = '';
    this.isLoading = true;
    this.validateSingleStampNew2('single').then(() => {
      this.isLoading = false;
    });
  }

  changeCheckboxStampBoxProduct() {
    this.checkboxBoxProductStamp = $('#checkboxStampBoxProduct').is(':checked')
    setTimeout(() => {
      $('#checkboxStampBoxProductVal').focus()
    }, 100)
  }

  onChangeRouting(e) {
    console.log('eeeeee', e.target.checked);
    if (this.groupItems.length > 0) {
      this.formCratingBatch.get('is_routing').setValue(e.target.checked);
      this.checktemp()
    }
    clickTracking('qcheck_stamp_distribute', 'btn_distribute_routing', '', '');
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  }

  setData(serial, bundleType, show_button_cancel?: boolean) {
    this.show_cancel_button = show_button_cancel || false;
    console.log(123, serial, bundleType);
    if (bundleType === 1) {
      this.reset('cratingStampsSingle');
    } else {
      this.reset('cratingProductSingle');
    }
    this.loadDataChild([serial]);
  }

  // removeCodeListAll() {
  //   while (this.codeList().length !== 0) {
  //     this.codeList().removeAt(0);
  //   }
  // }

  formatSerial2(id: any) {
    let serial_f = '';
    id = id.toString();
    if (id) {
      const pad = '000000';
      const serial = pad.substring(0, 6 - id.length) + id;
      serial_f = serial;
    }
    return serial_f;
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
      this.citiesAgency = citiesList;
    });
  }

  loadDistrictData(id) {
    console.log(123123123123);

    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        const districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
      });
  }

  loadDistrictAgency(id) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        const districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districtsAgency = districts;
      });
  }

  changeTab2(event) {
    this.activeTab2 = event;
    if (event == 1) {

    }
    if (event == 2) {
    }
  }

  showModal() {
    // console
    const data = {
      id: 'myModalCrating',
      title: 'THÊM DANH SÁCH TEM LẺ',
      contentMess: 'Bạn chưa nhập team lẻ',
      listContent: this.listContent,
      type: 'distribute'
    };
    this.boxRetalStamps.show(data);
  }

  // end boxRetalStamps
  isNaN(x) {
    // Ép kiểu Number cho biến x
    x = Number(x);
    // Nếu x là NaN, NaN != NaN trả về true, các trường hợp khác sẽ trả về false
    return x != x;
  }

  codeList(): FormArray {
    return this.formCratingBatch.get('stampCodeList') as FormArray;
  }

  newCodeList(): FormGroup {
    return this.fb.group({
      prefix: '',
      serialFirst: '',
      serialLast: '',
      data: [],
      mess: '',
    });
  }

  removeCodeList(i) {
    this.codeList().removeAt(i);
    this.checktemp();
    if (this.formCratingBatch.value.stampCodeList.length === 0 && this.stampList.length === 0) {
      this.groupItems = [];
    }
  }

  clearValue(i) {
    console.log('asdasdasd', i)
  }

  // boxRetalStamps
  removeItem(index) {
    this.listContent = this.listContent.filter((res, i) => i !== index);
    this.stampList = this.stampList.filter((res, i) => i !== index);
    console.log(' this.listContent', this.listContent)
    console.log(' this.stampList', this.stampList)
    if (this.stampList.length == 0) {
      this.errorMessage = [];
      // if (this.listContent.length === 0) {
      //   this.groupItems = [];
      // }
    }
    if (this.formCratingBatch.value.stampCodeList.length === 0 && this.stampList.length === 0) {
      this.groupItems = [];
    }
    this.checktemp();
  }

  closeDistribution() {
    this.hideComponent.emit({ hide: true });
  }

  // handle images when upload
  tusUploadReturnBoxImages = (item) => {
    let isValid = true;
    return new Promise((resolve) => {
      for (const image of item.target.files) {
        if (image.type.indexOf('image') === -1) {
          isValid = false;
        }
      }
      resolve(isValid);
    }).then((result) => {
      console.log(result);
      if (result) {
        for (const image of item.target.files) {
          const fileData = new FormData();
          // @ts-ignore
          fileData.append('file', image);
          return this.upload.uploadImagesNew2(fileData).subscribe((response: any) => {
            const res = JSON.parse(response._body)
            if (res.status === 200) {
              const image2 = {
                id: res.data.fileId,
                url: res.data.url,
              };
              this.listImageDistribution.push(image2);

            }
          });
        }
      } else {
        this.toastr.warning('Không đúng định dạng ảnh', 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    });
  };

  // delete image upload
  deleteImage(index: number) {
    this.listImageDistribution.splice(index, 1);
  }

  formatSerial(id: any, prefix: string) {
    let serial_f = '';
    id = id.toString();
    if (id && prefix) {
      const pad = '000000';
      const serial = pad.substring(0, 6 - id.length) + id;
      serial_f = prefix + '-' + serial;
    }
    return serial_f;
  }

  hideModalSelectBatchStamp() {
    $('#searchBatchStamp').modal('hide');
    $('.slt-batchstamp').val(null).trigger('change');
  }

  /** Gán chương trình cho sell-out */
  campaignChange() {
    console.log(123);
  }

  clearInputFile() {
    const input = $('#controlFile');
    input.wrap('<form>').closest('form').get(0).reset();
    input.unwrap();
  }

  openModalProgram() {
    $('#program').modal('show');
    this.activeTab2 = 1;
  }

  test() {
    console.log(123486090);
  }

  submitFormImportExcel() {
    // const routing = $('input[name=\'routing\']:checked').val();
    // const requiredAccept = $('input[name=\'requiredAccept\']:checked').val();
    const routingImport = this.formCratingBatch.value.is_routingImportTypeDistribution
    const requiredAcceptImport = this.formCratingBatch.value.is_request_import
    console.log('routingImport', routingImport, requiredAcceptImport)
    this.message = null;
    this.data_import_success = null;
    this.data_import_fail = null
    this.titleFile = this.translateService.instant('PS_CHON_FILE_UPLOAD');
    console.log('this.files ', this.files)
    console.log('this.files---2 ', this.files2)
    if (this.files !== null && this.files.length > 0) {
      const file = this.files[0];
      this.files = null;
      const file_name = file.name;
      const allowedExtensions = ['xlsx', 'xls', 'csv'];
      const fileExtension = file_name.split('.').pop();
      console.log('allowedExtensions', allowedExtensions)
      console.log('fileExtension', fileExtension)

      if (this.isInArray(allowedExtensions, fileExtension)) {
        //msg process
        this.message = {
          class: 'alert dark alert-warning',
          content: this.translateService.instant('HE_THONG_DANG_XU_LY_PHAN_PHOI_TEM')
        };
        //upload file
        // let body = {
        //   file: file,
        //   type: "1"
        // }
        // console.log("bodyyyyy", body);
        const query = {
          // requiredAccept: requiredAccept ? 1 : 0,
          // routing: !!routing
          requiredAccept: requiredAcceptImport ? 1 : 0,
          routing: routingImport == 'routingImport' ? true : false
        }
        console.log('query', query)
        this.boxStampDistributionService.uploadFileCustomer(file, query).subscribe((res: any) => {
          if (res.code === 1) {
            this.message = {
              class: 'alert dark alert-icon alert-success',
              content: this.translateService.instant('XU_LY_THANH_CONG_NHAN_KET_QUA'),
            };
            // this.message = null;

            // setTimeout(() => {
            //   this.pager = 1;
            //   this.loadData(this.paramsQuery, this.isSorting);
            // }, 1000);
            this.files2 = null;
            this.clearInputFile()
          } else {
            this.message = {
              class: 'alert dark alert-icon alert-danger',
              content: res.message
            }
          }
        }, error => {
          this.message = {
            class: 'alert dark alert-icon alert-danger',
            content: error.message
          };
        });
      } else {
        this.message = {
          class: 'alert alert-danger',
          content: this.translateService.instant('VUI_LONG_CHON_DUNG_FILE_EXCEL')
        };
      }
    } else {
      this.message = {
        class: 'alert alert-danger',
        content: this.translateService.instant('BAN_CHUA_CHON_FILE_DE_IMPORT')
      };
    }
  }

  openModalSingleStamp() {
    this.isLoading = false;
    $('#singleStamp').modal('show');
    $('.textAreaStampSingle').bind('input propertychange', _.debounce(this.validateSingleStamp, 1000));
  }

  hideModalProgramSellout() {
    $('#program').modal('hide');
    this.isActiveCampaignSellout = false;
    this.resetSellout();
    this.resetLoyalty();
  }

  hideModalProgramLoyalty() {
    $('#program').modal('hide');
    this.isActiveCampaignLoyalty = false;
    this.activeTab2 = 1;
    this.resetLoyalty();
    this.resetSellout();
  }

  hideModalProgram() {
    $('#program').modal('hide');
    this.activeTab2 = 1;
    this.isActiveCampaignSellout = false;
    this.resetSellout();
    this.isActiveCampaignLoyalty = false;
    this.resetLoyalty()
  }

  checkPrefix() {
    const data = {
      prefix: '',
      page: 1,
      pageSize: 100,
    }
    this.boxStampDistributionService.getPrefix(data).subscribe((res) => {
      if (res.code == 1) {
        this.checkPrefixData = res.data.items
        this.totalCheckPrefixData = res.data.total;
      }
    }, (error) => {
      this.toastr.warning(error.message, 'Thông báo', {
        timeOut: 4000,
        positionClass: 'toast-top-right',
      })
    })
  }

  setData2(data, bundleType) {
    console.log('data', data, bundleType)
    data.map((res) => {
      const arr = {
        prefix: res.prefix,
        serialFirst: this.formatSerial2(res.idStart),
        serialLast: this.formatSerial2(res.idEnd),
      }
      if (res.idStart == res.idEnd) {
        this.listStampHistoryActive.group.items.push(arr)
      } else {
        this.listStampsHistoryActive.group.items.push(arr)
      }
    })
    if (bundleType === 0) {
      this.reset('cratingProductSingle');
      console.log('this.listStampHistoryActive', this.listStampHistoryActive)
      this.loadDataChildStampHistoryActive(this.listStampHistoryActive);
      this.loadDataChildStampsHistoryActive(this.listStampsHistoryActive);

    } else {
      this.reset('cratingStampsSingle');
      this.loadDataChildStampHistoryActive(this.listStampHistoryActive);
      this.loadDataChildStampsHistoryActive(this.listStampsHistoryActive);
    }
  }

  loadDataChildStampHistoryActive(e) {
    const totalStamp = this.successListStamp.length + this.successCodeListStamp.length;
    const maxSize = this.max_quantity;
    const maxStampInput = maxSize - totalStamp
    if (totalStamp > maxSize) {
      $('#warningStamp').modal('show');
      return
    }
    if (maxStampInput <= 0) {
      $('#warningStamp').modal('show');
      return
    } else {
      console.log('totalStamp', totalStamp)
      console.log('e', e, maxStampInput)
      if (maxStampInput >= e.group.items.length) {
        console.log('dung hoac sai ')
        const tmp = [];
        e.group.items.map((res) => {
          const stamp = {
            prefix: res.prefix,
            idStart: res.serialFirst,
            idEnd: res.serialLast,
          };
          tmp.push(stamp);
        });
        this.addStampSingle('child', tmp);
      }
    }
  }

  loadDataChildStampsHistoryActive(e) {
    const totalStamp = this.successListStamp.length + this.successCodeListStamp.length;
    const maxSize = this.max_quantity;
    const maxStampInput = maxSize - totalStamp
    if (totalStamp > maxSize) {
      $('#warningStamp').modal('show');
      return
    }
    if (maxStampInput <= 0) {
      $('#warningStamp').modal('show');
      return
    } else {
      if (maxStampInput >= 0) {
        const tmp = [];
        console.log('eeeeees', e)
        e.group.items.map((res, index) => {
          const stamp = {
            prefix: res.prefix,
            idStart: res.serialFirst,
            idEnd: res.serialLast,
          }
          tmp.push(stamp);
        })
        this.addStampCodeList('child', tmp);
      }
    }
  }

  stampCodeChanged(i) {
    // const prefixNew = `prefix-new-${i}`
    // const prefixNew2 = $(`#${prefixNew}`).text().trim('');
    // $(`#${prefixNew}`).on('change', function (e){
    //   console.log('this.formCratingBatch.value.stampCodeList[i]')
    //   this.formCratingBatch.get(`stampCodeList[${i}]`).serialFirst.setValue('');
    //   this.formCratingBatch.get(`stampCodeList[${i}]`).serialLast.setValue('');
    //   // this.formCratingBatch.value.stampCodeList[i].serialFirst = '';
    //   // this.formCratingBatch.value.stampCodeList[i].serialLast = ''
    // })
    // this.formCratingBatch.value.stampCodeList[i].prefix = prefixNew2;
    // console.log('this.formCratingBatch.value.stampCodeList[i]', this.formCratingBatch.value.stampCodeList[i])
    console.log(222, this.formCratingBatch.value);
    if (
      this.formCratingBatch.value.stampCodeList[i].prefix.trim() !== '' &&
      this.formCratingBatch.value.stampCodeList[i].serialFirst.trim() !== '' &&
      this.formCratingBatch.value.stampCodeList[i].serialLast.trim() !== ''
    ) {
      console.log('vao day ko 123 ')
      if (
        parseInt(
          this.formCratingBatch.value.stampCodeList[i].serialFirst.trim()
        ) >
        parseInt(this.formCratingBatch.value.stampCodeList[i].serialLast.trim())
      ) {
        // console.log(1111);
        this.formCratingBatch.value.stampCodeList[i].mess =
          'Serial cuối phải lớn hơn Serial đầu';
      } else {
        this.formCratingBatch.value.stampCodeList[i].mess = '';
        this.checktemp();
      }
    } else {
      console.log('vao day ko ')
    }
  }

  array_equal(array1, array2) {
    //flag = true => 2 mảng đã cho giống nhau
    //flag = false => 2 mảng đã cho khác nhau
    let flag = true;
    /*Nếu số phần tử của 2 mảng khác nhau, thì chúng sẽ khác nhau*/
    if (array1.length !== array2.length) {
      return flag = false;
    }
    /*Kiểm tra từng cặp phần tử tương ứng xem có cặp nào khác nhau không*/
    for (let i = 0; i < array1.length; ++i) {
      if (array1[i] != array2[i]) {
        return flag = false;
      }
    }
    return flag;
  }

  backToList(data) {
    console.log('asda', data);
    this.hideDistribution.emit(data);
  }

  changeTab(event) {
    this.activeTab = event;
    this.formCratingBatch.get('note').setValue('');
    this.formCratingBatch.get('name').setValue('');
    this.listImageDistribution = []
    if (event == 1) {
      this.distriButionLocationStep3 = []
      this.listImageDistribution = []
      this.citiesNewsTab2 = [];
      this.listLocationNewTab2 = [];
      if (this.citiesNews.length == 0) {
        this.openListLocationNew();
      }
    }
    if (event == 2) {
      if (this.citiesNewsTab2.length == 0) {
        this.openListLocationNewTab2();
        this.addListLocationTab2();
      }
    }
  }

  loadDataChild(e) {
    console.log('e', e)
    const stampList = [];
    e.map((res) => {
      const splitSerial = res.split('-');
      let _serial: any = '';
      let _prefix: any = '';
      if (splitSerial.length > 1) {
        _serial = splitSerial.pop();
        _prefix = splitSerial[0];
      } else {
        _serial = NaN;
        _prefix = splitSerial[0];
      }

      const stamp = {
        prefix: _prefix,
        serialFirst: _serial,
        serialLast: _serial,
      };
      stampList.push(stamp);
    });
    this.stampList = stampList;
    console.log('tuanba', typeof this.stampList);
    this.checktemp();
    this.listContent = e;
    console.log('tesst', this.listContent);
  }

  loadDataChildNew(e) {
    console.log('e', e)
    e = e.toUpperCase().split('\n');
    e.map((res) => {
      const splitSerial = res.split('-');
      let _serial: any = '';
      let _prefix: any = '';
      if (splitSerial.length > 1) {
        _serial = splitSerial.pop();
        _prefix = splitSerial[0];
      } else {
        _serial = NaN;
        _prefix = splitSerial[0];
      }

      const stamp = {
        prefix: _prefix,
        serialFirst: _serial,
        serialLast: _serial,
      };
      this.stampList.push(stamp);
    });
    this.stampList = this.stampList.filter((res) => {
      return res.serialFirst == res.serialLast
    })
    this.stampList = this.stampList.reduce((unique, o) => {
      if (!unique.some(obj => obj.prefix === o.prefix && obj.serialFirst === o.serialFirst && obj.serialFirst === o.serialFirst)) {
        unique.push(o);
      }
      return unique;
    }, []);
  }

  showModalListSellout(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
    this.listOfChecked = '';
    this.pageIndex = 1;
    this.loadCampaignSellout();
  }

  closeModalCampaignSellout() {
    this.modalRef.hide();
    this.pageIndex = 1;
  }

  inputPageList(event) {
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex = page;
      // this.loading_left = true;
      this.loadCampaignSellout();
    }
  }

  prePageList() {
    if (this.pageIndex > 1) {
      this.pageIndex = this.pageIndex - 1;
      // this.loading_left = true;
      this.loadCampaignSellout();
    }
  }

  removeCampaignSellout() {
    this.myCampaign = null;
    this.verifyCampaignSellout = null;
    this.codeCampaignSellout = null;
    this.resetSellout();
  }

  // tìm kiếm lô tem
  showModalSelectBatchStamp() {
    $('#searchBatchStamp').modal('show');
    $('.slt-batchstamp').select2({
      placeholder: 'Tìm kiếm lô tem',
      allowClear: false,
      minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_parent_child: 1,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_parent_child: 1,
          };
        },
        processResults: function (data) {
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  return {
                    text: item.name,
                    id: item.prefix + '|' + item.id_start + '|' + item.id_end,
                  };
                })
                : [],
          };
        },
      },
    });
  }

  onMyCampaign() {
    this.checkSelectCampain = 1;
    // this.campaignCode = null;
  }

  onOtherCampaign() {
    this.checkSelectCampain = 2;
    this.isCampaign = false
    // this.myCampaign = {}
  }

  addCodeList() {
    // this.codeList().push(this.newCodeList());
    // console.log('ádasd', this.formCratingBatch.value.stampCodeList)
    const prefixNew = `prefix-new-${this.codeList().controls.length}`
    // console.log('prefix', prefixNew)
    // const that = this;
    // setTimeout(() => {
    //   $(`#${prefixNew}`).select2({
    //     tags: true,
    //     // maximumSelectionLength: 3,
    //     // insertTag: function (data, tag) {
    //     //   // Insert the tag at the end of the results
    //     //   data.push(tag);
    //     // },
    //     tokenSeparators: [",", " "],
    //     createSearchChoice: function(term, data) {
    //       if ($(data).filter(function() {
    //         return this.text.localeCompare(term) === 0;
    //       }).length === 0) {
    //         return {
    //           id: term,
    //           text: term
    //         };
    //       }
    //     },
    //     placeholder: 'Chọn prefix...',
    //     allowClear: true,
    //     ajax: {
    //       delay: 500,
    //       url: `${environment.qrcode_url_aps}/prefix`,
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
    //         'Content-Type': 'application/json',
    //       },
    //       dataType: 'json',
    //       data: function (params) {
    //         console.log('params11', params);
    //         if (params.term) {
    //           return {
    //             prefix: params.term,
    //             page: 1,
    //             pageSize: 50,
    //           };
    //         }
    //         return {
    //           page: 1,
    //           pageSize: 50,
    //         };
    //       },
    //       processResults: (data) => {
    //         if (data.data.items.length > 0) {
    //           return {
    //             results: data.data.items.map((item) => {
    //               return {
    //                 text: item.prefix,
    //                 id: item.id,
    //               };
    //             }),
    //           };
    //         }
    //
    //       },
    //     },
    //   });
    //
    //   // $(`#${prefixNew}`).on("select2:blur", function (e) {
    //   //   // e.type = 'blur';
    //   //   console.log("====================")
    //   // });
    //
    //   $('.aaaa').on('change', function (e){
    //     const index = $(this).attr('id').split('-')[2]
    //     console.log('this.formCratingBatch.value.stampCodeList[i]', `stampCodeList[${index}]`)
    //     const obj = [...that.formCratingBatch.value.stampCodeList]
    //     obj[index].serialFirst = '';
    //     obj[index].serialLast = '';
    //     that.formCratingBatch.get(`stampCodeList`).setValue(obj)
    //     console.log("that.formCratingBatch", that.formCratingBatch.value.stampCodeList)
    //     // that.formCratingBatch.controls[index]
    //     // that.formCratingBatch.value.stampCodeList[index].prefix = '';
    //     //
    //     // that.formCratingBatch.value.stampCodeList[index].serialFirst = '';
    //     // that.formCratingBatch.value.stampCodeList[index].serialLast = '';
    //     // console.log("that.formCratingBatch22", that.formCratingBatch.value.stampCodeList[index])
    //
    //     // that.formCratingBatch.get(`stampCodeList[${index}]`).serialFirst.setValue('');
    //     // that.formCratingBatch.get(`stampCodeList[${index}]`).serialLast.setValue('');
    //     // this.formCratingBatch.value.stampCodeList[i].serialFirst = '';
    //     // this.formCratingBatch.value.stampCodeList[i].serialLast = ''
    //   })
    // }, 100)
    // setTimeout(() => {
    //   $(`#${prefixNew}`).select2({
    //     placeholder: 'Chọn prefix...',
    //   });
    //   $('.select2-container.select2-container--default.select2-container--open').prop('z-index', 9999)
    //   console.log('$(\'.select2-container\')',)
    //   // $(`#${prefixNew}`).on('select2:select', function (e) {
    //   //   $('.select2-selection__rendered').removeAttr('title');
    //   //   const id = e.target.value;
    //   // });
    // }, 1)
  }

  resetSellout() {
    $('#myCampaign').prop('checked', false);
    $('#otherCampaign').prop('checked', false);
    this.checkSelectCampain = 0;
    this.campaignCode = '',
      this.pageIndex = 1;
    this.myCampaign = null;
  }

  resetLoyalty() {
    $('#service').prop('checked', false);
    $('#guarantee').prop('checked', false);
    $('input[name="scan"]').attr('checked', false);
    $('#scanfirst').prop('checked', false);
    $('#scanall').prop('checked', false);
    $('#myCampaignLoyalty').prop('checked', false);
    $('#otherCampaignLoyalty').prop('checked', false);
    this.giftCode = '';
    this.checkSelectCampainLoyalty = 0;
    this.campaignCodeLoyalty = '',
      this.changeService = 0;
    this.pageIndex_loyalty = 1;
    this.changeIdetification = false;
    this.changeOverflow = false;
    this.myCampaignLoyalty = null;
  }

  ngOnInit() {
    this.translateService.onLangChange.subscribe(() => {
      this.initTranslations();
    });
    this.initTranslations();
    this.getTypeDistribution();
    this.addCodeList();
    $('.slt-batchstamp').select2({
      placeholder: this.translateService.instant('TIM_KIEM_LO_TEM'),
      allowClear: false,
      minimumInputLength: 2,
      ajax: {
        delay: 1000,
        url: `${environment.api_evs}/batches`,
        headers: {
          authorization: `${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              offset: 0,
              limit: 150,
              show_parent_child: 1,
            };
          }
          return {
            offset: 0,
            limit: 150,
            show_parent_child: 1,
          };
        },
        processResults: function (data) {
          return {
            results:
              data.data && data.data.batches
                ? data.data.batches.map((item) => {
                  return {
                    text: item.name,
                    id: item.prefix + '|' + item.id_start + '|' + item.id_end,
                  };
                })
                : [],
          };
        },
      },
    });
    // console.log('tuándabsdsad22222', this.codeList().controls.length);
    // const prefixNew = `prefix-new-${this.codeList().controls.length}`;
    // console.log('tuándabsdsa1111d', prefixNew)
    // setTimeout(() => {
    //   console.log('vap day ko ')
    //   $(`#${prefixNew}`).select2({
    //     placeholder: 'Chọn prefix...',
    //     allowClear: true,
    //     ajax: {
    //       delay: 500,
    //       url: `${environment.qrcode_url_aps}/prefix`,
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
    //         'Content-Type': 'application/json',
    //       },
    //       dataType: 'json',
    //       data: function (params) {
    //         console.log('params11', params);
    //         if (params.term) {
    //           return {
    //             prefix: params.term,
    //             page: 1,
    //             pageSize: 50,
    //           };
    //         }
    //         return {
    //           page: 1,
    //           pageSize: 50,
    //         };
    //       },
    //       processResults: (data) => {
    //         if (data.data.items.length > 0) {
    //           return {
    //             results: data.data.items.map((item) => {
    //               return {
    //                 text: item.prefix,
    //                 id: item.id,
    //               };
    //             }),
    //           };
    //         }
    //
    //       },
    //     },
    //   });
    // }, 1)
    // setTimeout(() => {
    //   $(`#${prefixNew}`).select2({
    //     placeholder: 'Chọn prefix...',
    //   });
    //   $(`#${prefixNew}`).on('select2:select', function (e) {
    //     $('.select2-selection__rendered').removeAttr('title');
    //   });
    // }, 1)
    // if (this.dataStampHistoryActive.length > 0) {
    //   if (this.dataStampHistoryActive[0].bundleType == 0) {
    //     this.reset('cratingProductSingle')
    //     this.listContent = this.dataStampHistoryActive
    //   } else {
    //     this.reset('cratingStampsSingle')
    //   }
    // }
    console.log('dataStampHistoryActive', this.dataStampHistoryActive)
    const userInfo = localStorage.getItem('User');
    this.hiddenFMC = JSON.parse(userInfo).source == 4 ? true : false;
    baseTracking(environment.appIdTracking);
    console.log(45677)
    const cityAgent = $('.cityAgent');
    const districtAgent = $('.districtAgent');
    cityAgent
      .select2({ placeholder: this.translateService.instant('TINH_THANH'), allowClear: true })
      .prop('disabled', true);
    districtAgent
      .select2({ placeholder: this.translateService.instant('QUAN_HUYEN'), allowClear: true })
      .prop('disabled', true);

    this.getCity();
    // this.checkPrefix();
    const basicMultiple = $('.js-example-basic-multiple');
    const districtForAgencyArea = $('.districtForAgencyArea-multiple');
    basicMultiple.select2();
    districtForAgencyArea.select2();

    $('.address').prop('disabled', true);

    basicMultiple.on('select2:open', function () {
      $('.select2-container').addClass('setIndex-1800');
    });
    districtForAgencyArea.on('select2:open', function () {
      $('.select2-container').addClass('setIndex-1800');
    });
    basicMultiple.change(() => {
      if (basicMultiple.val() && basicMultiple.val().length > 1) {
        this.is_districtForAgencyArea = false;
        this.districtForAgencyArea = [];
        districtForAgencyArea.val([]).trigger('change');
      } else {
        this.is_districtForAgencyArea = true;
        if (basicMultiple.val()) {
          this.loadDistrictAgency(basicMultiple.val());
        } else {
          this.is_districtForAgencyArea = false;
          this.districtForAgencyArea = [];
          this.districtsAgency = [];
        }
      }
      this.agencyArea = basicMultiple.val();
    });

    districtForAgencyArea.change(() => {
      this.districtForAgencyArea = districtForAgencyArea.val();
    });

    // Area
    const city = $('.city');
    const district = $('.district');
    const addressArea = $('.addressArea');
    city.select2();
    district.select2();

    city.on('select2:open', function () {
      $('.select2-container').addClass('setIndex-1800');
    });
    district.on('select2:open', function () {
      $('.select2-container').addClass('setIndex-1800');
    });

    city.change(() => {
      console.log('val', city.val());

      if (city.val() && city.val().length > 1) {
        district.prop('disabled', true);
        addressArea.prop('disabled', true);

        district.val([]).trigger('change');
        addressArea.val(null);
        console.log('district.val(null)', district.val());
      } else {
        district.prop('disabled', false);
        addressArea.prop('disabled', false);
        if (city.val()) {
          this.loadDistrictData(city.val());
        } else {
          console.log('kkk');
          this.districts = [];
        }
      }
    });

    district.change(() => {
      if (
        district.val() === null ||
        (district.val() && district.val().length > 1)
      ) {
        addressArea.prop('disabled', true);
        addressArea.val(null);
      } else {
        addressArea.prop('disabled', false);
      }
    });
    // select2 search
    console.log(12365890);

    const distributionAgent = $('.distributionAgent1');
    distributionAgent.select2({
      placeholder: this.translateService.instant('AI_LY_PHAN_PHOI'),
      allowClear: true,
      ajax: {
        delay: 500,
        url: `${environment.qrcode_url}/agencies?status=1`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('Access-Token')}`,
          'Content-Type': 'application/json',
        },
        dataType: 'json',
        data: function (params) {
          console.log('params', params);
          $('.select2-container').addClass('setIndex-1800');
          if (params.term) {
            return {
              name: params.term,
              page: 1,
              page_size: 50,
            };
          }
          return {
            page: 1,
            page_size: 50,
          };
        },
        // tslint:disable-next-line:no-shadowed-variable
        processResults: (data) => {
          // this.fakeData = data.data.items;
          // console.log('data', this.fakeData)
          return {
            results: data.data.items.map((item) => {
              return {
                text: item.name,
                id: item.id,
              };
            }),
          };
        },
      },
    });

    distributionAgent.change(() => {
      this.listLocationNew = []
      console.log('distributionAgent.val()', distributionAgent.val());
      if (distributionAgent.val() !== null) {
        this.boxStampDistributionService
          .detailAgencies(distributionAgent.val())
          .subscribe((val) => {
            this.detailAgencyLocation = val.data.location
            this.openListLocationNew();
            if (val.data.location && val.data.location.itemV1) {
              this.isLocationItem = 1;
              this.showCityDistrictNew = val.data.location != null ? true : false;
              if (val.data.location.itemV1.length > 0) {
                this.listLocationNew = val.data.location.itemV1;
                this.listLocationNew.map((res, index) => {
                  // setTimeout(() => {
                  //   $(`#${area_new}`).select2({
                  //     placeholder: 'Chọn Tỉnh thành',
                  //   });
                  //   $(`#${area_new_district}`).select2({
                  //     placeholder: 'Chọn Quận/ Huyện',
                  //     allowClear: true,
                  //   });
                  //   const that = this
                  //   $(`#${area_new}`).on('select2:select', function (e) {
                  //     $('.select2-selection__rendered').removeAttr('title');
                  //     const id = e.target.value;
                  //     that.getDistrictNew(id, 'district_modal_new', length);
                  //   });
                  // }, 0)
                  this.getDistrictNew(res.provinceId, 'district_modal_new', index);
                  setTimeout(() => {
                    $(`#area_new-${index}`).select2({
                      placeholder: this.translateService.instant('CHON_TINH_THANH'),
                    })
                    $(`#area_new_district-${index}`).select2({
                      placeholder: this.translateService.instant('CHON_QUAN_HUYEN_1'),
                    }).val(res.districtIds).trigger('change')
                    const that = this
                    $(`#area_new-${index}`).on('select2:select', function (e) {
                      $('.select2-selection__rendered').removeAttr('title');
                      const id = e.target.value;
                      that.getDistrictNew(id, 'district_modal_new', index);
                    });
                  }, 0);
                })
              } else {
                this.addListLocation();
              }
              console.log('this.listLocationNew22222', this.listLocationNew);
            } else {
              this.showCityDistrictNew = true;
              this.listLocationNew = [];
            }
            if (val.data.location && val.data.location.item && !val.data.location.itemV1) {
              this.isLocationItem = 2;
              this.listLocationNew.push(val.data.location.item);
              console.log('this.listLocationNewNotV1', this.listLocationNew)
              this.listLocationNew.map((res, index) => {
                res.provinceIds.map((val, index) => {
                  this.addressService.getDistrict({ city_id: val }).subscribe(
                    (res2) => {
                      if (res2.status === 200) {
                        console.log('asfasf', res2);
                        const citiesListNew = [];
                        const items = res2.data.districts;
                        items.map((item) => {
                          citiesListNew.push({
                            label: item.name,
                            id: item.id,
                          });
                        });
                        this.listLocationNew[index]['districtIdsItems'] = citiesListNew
                        return;
                      } else {
                      }
                    },
                    (error) => {
                    }
                  );
                })
                setTimeout(() => {
                  $(`#area_new-${index}`).select2({
                    placeholder: this.translateService.instant('CHON_TINH_THANH_1'),
                  })
                  $(`#area_new_district-${index}`).select2({
                    placeholder: this.translateService.instant('CHON_QUAN_HUYEN_1'),
                  }).val(res.districtIds).trigger('change')
                  const that = this
                  $(`#area_new-${index}`).on('select2:select', function (e) {
                    $('.select2-selection__rendered').removeAttr('title');
                    const id = e.target.value;
                    that.getDistrictNew(id, 'district_modal_new', index);
                  });
                }, 0);

              })
              console.log('listLocationNewNotV1', this.listLocationNew)
            }
            console.log('val', val);
            this.addressAgent = val.data.address;
            // tslint:disable-next-line:radix
            this.showCityAgent = val.data.provinceId !== null;
            this.showDistrictAgent = val.data.districtId !== null;

            if (this.showCityAgent) {
              if (
                val.data.location &&
                val.data.location.item.provinceIds.length > 0
              ) {
                $('.js-example-basic-multiple')
                  .val(val.data.location.item.provinceIds)
                  .trigger('change');
                if (val.data.location.item.provinceIds.length === 1) {
                  this.addressService
                    .getDistrict({
                      city_id: val.data.location.item.provinceIds[0],
                    })
                    .toPromise()
                    .then((res) => {
                      const districts = [];
                      res.data.districts.forEach((c: any) => {
                        districts.push({
                          value: c.name,
                          label: c.name,
                          id: c.id,
                        });
                      });
                      this.districtsAgency = districts;
                      console.log(
                        'val.data.location.item.districtsIds',
                        val.data.location.item.districtIds
                      );

                      setTimeout(() => {
                        $('.districtForAgencyArea-multiple')
                          .val(val.data.location.item.districtIds)
                          .trigger('change');
                      }, 500);
                    });
                }
              }

              // tslint:disable-next-line:no-shadowed-variable
              const cityAgent = $('.cityAgent');
              cityAgent.val(val.data.provinceId).trigger('change');
              if (this.showDistrictAgent) {
                // tslint:disable-next-line:no-shadowed-variable
                const districtAgent = $('.districtAgent');
                this.addressService
                  .getDistrict({ city_id: val.data.provinceId })
                  .toPromise()
                  .then((res) => {
                    const districts = [];
                    res.data.districts.forEach((c: any) => {
                      districts.push({
                        value: c.name,
                        label: c.name,
                        id: c.id,
                      });
                    });
                    this.distributionAgent = districts;
                    setTimeout(() => {
                      districtAgent.val(val.data.districtId).trigger('change');
                    }, 500);
                  });
              }
            }
          });
      } else {
        this.addressAgent = '';
        this.showCityAgent = false;
        this.showDistrictAgent = false;
        this.showCityDistrictNew = false;
        cityAgent.val(null).trigger('change');
        districtAgent.val(null).trigger('change');
        $('.js-example-basic-multiple').val([]).trigger('change');
        $('.districtForAgencyArea-multiple').val([]).trigger('change');
        this.listLocationNew = []
      }
    });

    // this.formCratingBatch.controls['is_routing'].valueChanges.subscribe(
    //   (val) => {
    //     // $("html, body").animate({ scrollTop: 0 }, "slow");
    //     // this.listContent = [];
    //     // this.errorMessage = [];
    //     // this.groupItems = [];
    //     // this.formCratingBatch.controls['stampCodeList'].reset();
    //     // this.codeList();
    //     this.checktemp();
    //   }
    // );
  }

  reset(e) {
    console.log('eas', e)
    // if (e === 'cratingStampsSingle') {
    //   clickTracking('qcheck_stamp_distribute', 'btn_distribute_box', 'distribute_box');
    // } else {
    //   clickTracking('qcheck_stamp_distribute', 'btn_distribute_stamp', 'distribute_stamp');
    // }
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.listContent = [];
    // this.removeCodeListAll();
    this.groupItems = [];
    this.errorMessage = [];
    this.stampList = [];
    this.formCratingBatch.reset();
    this.formCratingBatch.get('is_cratingStamps').setValue(e);
    this.getTypeDistribution();
    // this.formCratingBatch.get('is_request').setValue(true);
    // this.formCratingBatch.get('is_routing').setValue(false);
    this.listImageDistribution = [];
    this.addressAgent = '';
    this.showCityAgent = false;
    this.showDistrictAgent = false;
    this.addContent = '';
    this.errorMessageStamSingle = [];
    this.isLoading = false;
    this.timeout = null;
    this.checkboxSigle = false;
    this.checkboxBoxProductStamp = false
    this.successInternalCodes = []; // Reset successInternalCodes khi reset component
    $('.distributionAgent1').val(null).trigger('change');
    $('.cityAgent').val(null).trigger('change');
    $('.districtAgent').val(null).trigger('change');
    $('.js-example-basic-multiple').val([]).trigger('change');
    $('.districtForAgencyArea-multiple').val([]).trigger('change');
    $('.city').val([]).trigger('change');
    $('.district').val([]).trigger('change');
    this.nextStep(1, '');
    this.clearErrorStamp();
  }

  public arrayStampSuccesExceed = [];

  closeComponentDistribution() {
    this.loadDataParent.emit(true)
  }

  lastPageList() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )
    this.pageIndex = this.pageIndex + 1
    this.loadCampaignSellout();
  }

  public click = 0;

  cssClass(value) {
    this.click += 1;
    console.log('this.click', this.click);
    if (this.click % 2 != 0) {
      $(`.${value}`).css('margin-top', '32px')
    } else {
      $(`.${value}`).css('margin-top', '0px')
    }
  }


  async changeCheckboxSigleValue() {
    console.log('123123123')
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    let tmp = $('#checkboxSigleVal').val()
    tmp = tmp[0] + tmp.slice(1)
    console.log('tmap', tmp)
    $('#checkboxSigleVal').val('')
    this.timeout = setTimeout(async () => {
      let id = '';
      if (tmp.search('http') !== -1 || tmp.search('Http') !== -1) {
        const splitLink = tmp.split('/')
        id = splitLink[splitLink.length - 1]
      } else {
        id = tmp
      }

      if (id) {
        console.log('id', id)
        await this.boxStampDistributionService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              console.log(this.listContent)
              const totalStamp = this.successListStamp.length + this.successCodeListStamp.length;
              const maxSize = this.max_quantity;
              const maxStampInput = maxSize - totalStamp
              console.log('totalStamp', totalStamp)
              if (totalStamp >= maxSize) {
                $('#warningStamp').modal('show');
                return;
              }
              if ((maxSize - totalStamp) <= 0) {
                $('#warningStamp').modal('show');
                return;
              } else {
                if (maxStampInput >= 0) {
                  this.addStampSingle('scan', val.data);
                  // this.loadDataChildNew([...this.listContent, ...val.data])
                  // this.loadDataChildNew(val.data)
                  // this.validateSingleStampNew('single');
                }
              }
            } else {
              this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }

    }, 0);
    setTimeout(() => {
      $('#checkboxSigleVal').focus()
    }, 100)
  }

  async changeCheckboxStampBoxProductSingleValue() {
    console.log('123123123')
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    let tmp = $('#checkboxStampBoxProductVal').val()
    tmp = tmp[0] + tmp.slice(1)
    console.log('tmap', tmp)
    $('#checkboxStampBoxProductVal').val('')
    this.timeout = setTimeout(async () => {
      let id = '';
      if (tmp.search('http') !== -1 || tmp.search('Http') !== -1) {
        const splitLink = tmp.split('/')
        id = splitLink[splitLink.length - 1]
      } else {
        id = tmp
      }

      if (id) {
        console.log('id', id)
        await this.boxStampDistributionService
          .detailStamp(id)
          .subscribe((val) => {
            if (val.code === 1) {
              console.log(this.listContent)
              const totalStamp = this.successListStamp.length + this.successCodeListStamp.length;
              const maxSize = this.max_quantity;
              const maxStampInput = maxSize - totalStamp
              console.log('totalStamp', totalStamp)
              if (totalStamp >= maxSize) {
                $('#warningStamp').modal('show');
                return;
              }
              if ((maxSize - totalStamp) <= 0) {
                $('#warningStamp').modal('show');
                return;
              } else {
                if (maxStampInput >= 0) {
                  this.addStampSingle('scan', val.data);
                  // this.loadDataChildNew([...this.listContent, ...val.data])
                  // this.loadDataChildNew(val.data)
                  // this.validateSingleStampNew('single');
                }
              }
            } else {
              this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            }
            console.log('val', val)
          })
      } else {
        this.toastr.warning('Tem không hợp lệ', 'Cảnh báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }

    }, 0);
    setTimeout(() => {
      $('#checkboxStampBoxProductVal').focus()
    }, 100)
  }

  nextStep(e, params) {

    console.log('wwwww', e)
    // this.step = e
    if (e === 1) {
      this.step = e
      console.log('this.e', this.step)
      // this.clearErrorStamp();
    } else if (e === 2) {
      // this.clearErrorStamp();
      console.log('this.e2', this.step)
      console.log('this.distriButionAgencyTextStep3111111', this.distriButionAgencyTextStep3, this.distriButionAgencyTextStep3)
      if (this.activeTab === 1) {
        const distributionAgent = $('.distributionAgent1');
        console.log('distributionAgent', distributionAgent.val());
        if (distributionAgent.val() === null) {
          this.toastr.warning(this.translateService.instant('BAN_CHUA_CHON_DAI_LY_PHAN_PHOI'), this.translateService.instant('CANH_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          return;
        }
      } else {
        console.log('thissasdasd', this.listLocationNewTab2)
        if (this.listLocationNewTab2.length == 0) {
          this.toastr.warning(this.translateService.instant('BAN_CHUA_CHON_TINH_THANH'), this.translateService.instant('CANH_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          return;
        } else {
          let error = false
          this.listLocationNewTab2.map((res) => {
            if (res.districtIdsItems.length == 0) {
              error = true
            }
          })
          if (error) {
            this.toastr.warning(this.translateService.instant('BAN_CHUA_CHON_TINH_THANH'), this.translateService.instant('CANH_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            return;
          }
        }
        const city = $('.city');
        if (city.val() === null) {
          this.toastr.warning(this.translateService.instant('BAN_CHUA_CHON_TINH_THANH'), this.translateService.instant('CANH_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          return;
        }
      }
      this.step = e
    } else {
      console.log('this.e4', this.step)
      // this.openListLocationNew();
      // this.openListLocationNewTab2();

      if (this.errorListStamp.length > 0 || this.errorCodeListStamp.length > 0) {
        this.toastr.warning(this.translateService.instant('KHONG_THE_PHAN_PHOI_TEM_LOI'), this.translateService.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      } else {
        this.groupItems = [...this.successListStamp, ...this.successCodeListStamp]
      }
      console.log(' this.groupItems', this.groupItems)
      this.groupItems = this.groupItems.reduce((unique, o) => {
        if (!unique.some(obj => obj.prefix === o.prefix && obj.idStart === o.idStart && obj.idEnd === o.idEnd)) {
          unique.push(o);
        }
        return unique;
      }, []);
      console.log('this.groupItems', this.groupItems)
      console.log('this.errorMessage', this.errorMessage)
      clickTracking('qcheck_stamp_distribute', 'btn_distribute_stamp', 'qcheck_stamp_distribute', '');
      visibleContent('qcheck_distribute_history', 'qcheck_stamp_distribute', '');
      // if (this.groupItems.length <= 0) {
      //   this.toastr.warning('Bạn chưa nhập tem', 'Cảnh báo', {
      //     timeOut: 3000,
      //     positionClass: 'toast-top-right',
      //   });
      //   return;
      // } else if (this.errorMessage.length > 0) {
      //   this.toastr.error('Tem đang bị lỗi', 'Cảnh báo', {
      //     timeOut: 3000,
      //     positionClass: 'toast-top-right',
      //   });
      //   return;
      // }

      console.log('vao?', this.codeCampaignSellout, 'and', this.listOfChecked)
      let groupItemsWithType
      // Xử lý thêm validate cho gán chương trình sellout hoặc loyalty
      if (this.formCratingBatch.value.is_cratingStamps === 'cratingStampBoxProduct') {
        groupItemsWithType = this.groupItems.map((gg) => {
          gg.bundleType = gg.bundleType
          return gg;
        });
      } else {
        groupItemsWithType = this.groupItems.map((gg) => {
          gg.bundleType =
            this.formCratingBatch.value.is_cratingStamps === 'cratingStampsSingle'
              ? 1
              : 0;
          return gg;
        });
      }

      let body;
      console.log('dsell-out', this.verifyCampaignSellout, '-asdasd', this.verifyCampaignLoyalty);

      if (this.isEmpty(this.verifyCampaignSellout) === false && this.isEmpty(this.verifyCampaignLoyalty) === true) {
        console.log('tuan', 1)
        body = [
          {
            stampGroups: groupItemsWithType,
            systemType: 0, // 0: sellout, 1: loyalty
            campaignId: this.verifyCampaignSellout.campaignId ? Number(this.verifyCampaignSellout.campaignId) : '',
            campaignCode: this.verifyCampaignSellout.campaignCode ? this.verifyCampaignSellout.campaignCode : '',
            campaignType: this.verifyCampaignSellout.campaignType
          }
        ]
      } else if (this.isEmpty(this.verifyCampaignLoyalty) === false && this.isEmpty(this.verifyCampaignSellout) === true) {
        console.log('tuan', 2)
        body = [
          {
            stampGroups: groupItemsWithType,
            systemType: 1,
            campaignId: this.verifyCampaignLoyalty.campaignId ? Number(this.verifyCampaignLoyalty.campaignId) : '',
            campaignCode: this.verifyCampaignLoyalty.campaignCode ? this.verifyCampaignLoyalty.campaignCode : '',
            campaignType: this.verifyCampaignLoyalty.campaignType,
            giftCode: this.verifyCampaignLoyalty.giftCode,
            priority: this.verifyCampaignLoyalty.priority,
            applyScan: this.applyScan === '' ? '' : Number(this.applyScan),
          }
        ]
      } else if (this.isEmpty(this.verifyCampaignSellout) === false && this.isEmpty(this.verifyCampaignLoyalty) === false) {
        console.log('tuan', 3)
        body = [
          {
            stampGroups: groupItemsWithType,
            systemType: 0, // 0: sellout, 1: loyalty
            campaignId: this.verifyCampaignSellout.campaignId ? Number(this.verifyCampaignSellout.campaignId) : '',
            campaignCode: this.verifyCampaignSellout.campaignCode ? this.verifyCampaignSellout.campaignCode : '',
            campaignType: this.verifyCampaignSellout.campaignType
          },
          {
            stampGroups: groupItemsWithType,
            systemType: 1,
            campaignId: this.verifyCampaignLoyalty.campaignId ? Number(this.verifyCampaignLoyalty.campaignId) : '',
            campaignCode: this.verifyCampaignLoyalty.campaignCode ? this.verifyCampaignLoyalty.campaignCode : '',
            campaignType: this.verifyCampaignLoyalty.campaignType,
            giftCode: this.verifyCampaignLoyalty.giftCode,
            priority: this.verifyCampaignLoyalty.priority,
            applyScan: this.applyScan === '' ? '' : Number(this.applyScan),
          }
        ]
      }
      console.log('body', body)
      const errMess = [];
      let allItem = [];
      if (body) {
        this.boxStampDistributionService.validateCampaignsSellout(body).subscribe((res) => {
          if (res.code === 1) {
            allItem = res.data.items.map((val) => {
              return val.campaignSettings;
            });
            console.log(allItem, res.data);

            if (allItem.length > 0) {
              console.log('asdadasd');
              allItem.map((val) => {
                val.map((res) => {
                  if (res.errMessage !== null) {
                    let mess = '';
                    if (res.idStart === res.idEnd) {
                      mess = this.formatSerial(res.idStart, res.prefix.toUpperCase()) + ' : ' + res.errMessage;
                    } else {
                      mess = this.formatSerial(res.idStart, res.prefix.toUpperCase())
                        + ' -> ' + this.formatSerial(res.idEnd, res.prefix.toUpperCase())
                        + ' : ' + res.errMessage;
                    }
                    errMess.push(mess);
                  }
                })
              })
            }

            if (errMess.length > 0) {
              this.errMessageValidate = errMess;
              this.toastr.error(this.errMessageValidate.toString(), this.translateService.instant('CANH_BAO'), {
                timeOut: 3000,
                positionClass: 'toast-top-right',
              });
            } else {
              this.step = e
              this.errMessageValidate = [];
            }
          } else {
            this.errMessageValidate = [res.message];
            this.toastr.error(this.errMessageValidate.toString(), this.translateService.instant('CANH_BAO'), {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
            return;
          }
        }, (err) => {
          console.log(err);
          if (err && err.message) {
            this.errMessageValidate = [];
            this.errMessageValidate.push(err.message)
          } else {
            this.errMessageValidate = [this.translateService.instant('DA_CO_LOI_XAY_RA')]
          }
        });

      } else if (e === 3) {
        this.submitFormConfirm(params)
      }
    }
  }

  validateSingleStamp = () => {
    const routing = this.formCratingBatch.value.is_routing;
    const type = this.formCratingBatch.value.is_cratingStamps;
    const errorMess = [];
    const convertAddContent = this.listContent;
    const content = convertAddContent
    const stampList = [];
    if (content.length > 0) {
      content.map((res) => {
        if (res.trim().length > 0) {
          const splitSerial = res.split('-');
          let _serial: any = '';
          let _prefix: any = '';
          if (splitSerial.length > 1) {
            _serial = splitSerial.pop();
            _prefix = splitSerial[0];
          } else {
            _serial = NaN;
            _prefix = splitSerial[0];
          }
          const stamp = {
            prefix: _prefix.toUpperCase(),
            serialFirst: _serial.toString() == 'NaN' ? null : _serial.toString(),
            serialLast: _serial.toString() == 'NaN' ? null : _serial.toString(),
          };
          stampList.push(stamp);
        }
      })
    }
    console.log('stamppp', stampList)
    let data = [];
    if (this.formCratingBatch.value.stampCodeList.length > 0 && stampList.length > 0) {
      console.log(555667, this.formCratingBatch.value.stampCodeList, stampList);
      const tmpFormCrating = this.formCratingBatch.value.stampCodeList.map(
        (gg) => {
          return {
            prefix: gg.prefix.trim(),
            serialFirst: gg.serialFirst.trim(),
            serialLast: gg.serialLast.trim(),
          };
        }
      );
      data = tmpFormCrating.concat(stampList);
    }
    if (this.formCratingBatch.value.stampCodeList.length > 0 && stampList.length === 0) {
      data = this.formCratingBatch.value.stampCodeList.map((gg) => {
        return {
          prefix: gg.prefix.trim(),
          serialFirst: gg.serialFirst.trim(),
          serialLast: gg.serialLast.trim(),
        };
      });
    }
    if (this.formCratingBatch.value.stampCodeList.length === 0 && stampList.length > 0) {
      data = this.stampList.concat(stampList);
    }
    console.log('data', data);
    if (data.length > 0) {
      const convertValidate = [...data];
      console.log('convertValidate', convertValidate)
      const validateAPI = [];
      convertValidate.map((res) => {
        if (res.prefix) {
          if (res.prefix.trim() !== '' &&
            res.serialFirst !== '' &&
            res.serialLast !== '') {
            validateAPI.push({
              prefix: res.prefix.toUpperCase(),
              idStart: res.serialFirst,
              idEnd: res.serialLast,
            });
          }
        }
      });
      console.log('validare', validateAPI)
      const body = {
        routing: routing,
        group: {
          items: validateAPI,
        },
        type: type === 'cratingStampsSingle' ? 0 : 1,
      };
      // @ts-ignore
      // if(validateAPI === 0){
      //   this.errorMessage = ['Stop...'];
      //   return
      // }
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = null;
      }

      this.timeout = setTimeout(async (res) => {
        await this.boxStampDistributionService.transferValidate(body).subscribe(
          (res) => {
            console.log('res rtra ve', res)
            let allItem = [];
            if (res.code === 1) {
              allItem = res.data.items.map((val) => {
                if (val.listParent) {
                  val.listParent.map((pa) => {
                    pa.child = {
                      idStart: val.idStart,
                      idEnd: val.idEnd,
                      prefix: val.prefix,
                    };
                    return pa;
                  });
                }
                return val;
              });
              console.log('allItem', allItem)
              if (allItem.length == res.data.totalElement) {
                allItem.map((val) => {
                  if (val.errorMessage !== null) {
                    let mess = '';
                    if (val.idStart === val.idEnd) {
                      mess = this.formatSerial(val.idStart, val.prefix.toUpperCase()) + ' : ' + (val.errorMessage ? (val.errorMessage.includes('Thùng chứa tem đã quét') ? this.translateService.instant('THUNG_CHUA_TEM_DA_QUET') : val.errorMessage) : '');
                    } else {
                      mess = this.formatSerial(val.idStart, val.prefix.toUpperCase()) + ' -> '
                        + this.formatSerial(val.idEnd, val.prefix.toUpperCase()) + ' : ' + (val.errorMessage ? (val.errorMessage.includes('Thùng chứa tem đã quét') ? this.translateService.instant('THUNG_CHUA_TEM_DA_QUET') : val.errorMessage) : '');
                    }
                    errorMess.push(mess);
                  }
                  // check tem cha - con trùng nhau
                  const excludeArray = res.data.items.filter(
                    (gg) => gg.prefix != val.prefix || gg.idStart != val.idStart
                  );
                  const listParent = excludeArray.reduce(
                    (r, a) => r.concat(a.listParent),
                    []
                  );
                  if (listParent) {
                    const isExistedItem = listParent.find(
                      (pa) =>
                        pa.prefix == val.prefix &&
                        (pa.number == val.idStart || pa.number == val.idEnd)
                    );
                    const insideExistedItem = listParent.find(
                      (pa) =>
                        pa.prefix == val.prefix &&
                        pa.number > val.idStart &&
                        pa.number < val.idEnd
                    );
                    if (isExistedItem) {
                      if (isExistedItem.child) {
                        // tem lẻ có cha là tem lẻ khác trong list tem lẻ gửi lên
                        if (
                          isExistedItem.child.idStart == isExistedItem.child.idEnd
                        ) {
                          const mess =
                            this.formatSerial(
                              val.idStart,
                              val.prefix.toUpperCase()
                            ) +
                            ' : ' + this.translateService.instant('LA_TEM_THUNG_CHA_CUA_TEM') +
                            this.formatSerial(
                              isExistedItem.child.idStart,
                              isExistedItem.child.prefix.toUpperCase()
                            );
                          errorMess.push(mess);
                        }
                        // dải tem có cha là đầu/cuối của dải tem khác
                        else {
                          const mess =
                            this.formatSerial(
                              val.idStart,
                              val.prefix.toUpperCase()
                            ) +
                            ' : ' + this.translateService.instant('LA_TEM_CHA_CUA_DAI_TEM') +
                            this.formatSerial(
                              isExistedItem.child.idStart,
                              isExistedItem.child.prefix.toUpperCase()
                            ) +
                            ' -> ' +
                            this.formatSerial(
                              isExistedItem.child.idEnd,
                              isExistedItem.child.prefix.toUpperCase()
                            );
                          errorMess.push(mess);
                        }
                      }
                    }
                    // tem thùng lẻ / dải tem có cha trong dải tem
                    if (insideExistedItem) {
                      if (insideExistedItem.child) {
                        if (
                          insideExistedItem.child.idStart ==
                          insideExistedItem.child.idEnd
                        ) {
                          const mess =
                            this.translateService.instant('TEM') + ' ' +
                            this.formatSerial(
                              insideExistedItem.child.idStart,
                              insideExistedItem.child.prefix
                            ) +
                            this.translateService.instant('CO_TEM_THUNG_CHA') +
                            this.formatSerial(
                              insideExistedItem.number,
                              insideExistedItem.prefix
                            ) +
                            this.translateService.instant('NAM_TRONG_DAI_TEM') +
                            this.formatSerial(val.idStart, val.prefix) +
                            ' -> ' +
                            this.formatSerial(val.idEnd, val.prefix);

                          errorMess.push(mess);
                        } else {
                          const mess =
                            this.translateService.instant('DAI_TEM') + ' ' +
                            this.formatSerial(
                              insideExistedItem.child.idStart,
                              insideExistedItem.child.prefix
                            ) +
                            ' -> ' +
                            this.formatSerial(
                              insideExistedItem.child.idEnd,
                              insideExistedItem.child.prefix
                            ) +
                            this.translateService.instant('CO_TEM_THUNG_CHA') +
                            this.formatSerial(
                              insideExistedItem.number,
                              insideExistedItem.prefix
                            ) +
                            this.translateService.instant('NAM_TRONG_DAI_TEM') +
                            this.formatSerial(val.idStart, val.prefix) +
                            ' -> ' +
                            this.formatSerial(val.idEnd, val.prefix);

                          errorMess.push(mess);
                        }
                      }
                    }
                  }
                  if (val.errorMessage == null || val.errorMessage == '') {
                    this.successListStamp.push(val)
                    console.log(val)
                  } else {
                    this.errorListStamp.push(val)
                    console.log(val)
                  }
                });
                if (errorMess.length > 0) {
                  this.errorMessageStamSingle = errorMess;
                } else {
                  this.errorMessageStamSingle = [];
                  this.isLoading = true;
                  // this.listContent = stampList;
                }
              }
            } else {
              this.errorMessageStamSingle = [res.message];
            }
          },
          (err) => {
            this.errorMessageStamSingle = err.message
              ? [err.message]
              : [this.translateService.instant('KIEM_TRA_TEM_BI_LOI')];
          }
        );
        console.log('resultant2', this.successListStamp, this.errorListStamp)
      }, 500)
    } else {
      this.errorMessageStamSingle = [];
      this.errorMessage = [];
      this.addContent = '';
    }
  }

  addContentFunc() {
    if (this.errorMessageStamSingle.length > 0) {
      console.log('errorms', this.errorMessage, this.listContent);
    } else {
      console.log(this.listContent);
      const e = this.addContent.toUpperCase().split('\n');
      e.map((res) => {
        if (res.trim().length > 0) {
          this.listContent.push(res.trim());
        }
      })
      e.map((res) => {
        if (res.trim().length > 0) {
          const splitSerial = res.split('-');
          let _serial: any = '';
          let _prefix: any = '';
          if (splitSerial.length > 1) {
            _serial = splitSerial.pop();
            _prefix = splitSerial[0];
          } else {
            _serial = NaN;
            _prefix = splitSerial[0];
          }
          const stamp = {
            prefix: _prefix,
            serialFirst: _serial,
            serialLast: _serial,
          };
          this.stampList.push(stamp);
        }
      });
      const convertValidate = [...this.stampList];
      const validateAPI = [];
      convertValidate.map((res) => {
        if (res.serialFirst && res.serialLast && res.serialFirst !== 'NaN' && res.serialLast !== 'NaN') {
          if (res.prefix.trim() !== '' &&
            res.serialFirst.trim() !== '' &&
            res.serialLast.trim() !== '') {
            validateAPI.push({
              prefix: res.prefix.toUpperCase(),
              idStart: res.serialFirst.toString(),
              idEnd: res.serialLast.toString(),
            });
          }
        }
      });
      this.groupItems = this.groupItems.concat(validateAPI)
      console.log('result', this.groupItems);
      this.isLoading = true;
      $('#singleStamp').modal('hide');
      this.addContent = '';
      this.errorMessageStamSingle = [];
      console.log('errorms2', this.errorMessage, this.listContent);
    }
  }


  submitFormConfirm(data_post: any) {

    this.distriButionLocationStep3 = [];
    console.log('data_poasrt', data_post)
    console.log('vava', this.verifyCampaignLoyalty, this.verifyCampaignSellout);
    this.groupItems = this.successCodeListStamp.concat(this.successListStamp);
    console.log('this.groupItems', this.groupItems)
    this.disableSubmitFormConfirm = true
    if (this.groupItems.length <= 0) {
      this.toastr.warning(this.translateService.instant('BAN_CHUA_NHAP_TEM'), this.translateService.instant('CANH_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
      return;
    }
    // } else if (this.errorMessage.length > 0) {
    //   this.toastr.error('Tem đang bị lỗi', 'Cảnh báo', {
    //     timeOut: 3000,
    //     positionClass: 'toast-top-right',
    //   });
    //   return;
    // } else {
    let body: any = {};
    let bodyDistribute: any = {};
    let groupItemsWithType
    if (this.formCratingBatch.value.is_cratingStamps === 'cratingStampBoxProduct') {
      console.log('vao day ')
      groupItemsWithType = this.groupItems.map((gg) => {
        gg.bundleType = gg.bundleType
        gg.prefix = gg.prefix
        gg.idStart = gg.idStart
        gg.idEnd = gg.idEnd
        return gg;
      });
    } else {
      console.log('vao day 22 ')
      groupItemsWithType = this.groupItems.map((gg) => {
        gg.bundleType = this.formCratingBatch.value.is_cratingStamps === 'cratingStampsSingle' ? 1 : 0;
        gg.prefix = gg.prefix
        gg.idStart = gg.idStart
        gg.idEnd = gg.idEnd
        return gg;
      });
    }
    console.log('campaign code ', this.campaignCode);
    console.log('campaign cod2222e ', groupItemsWithType);
    if (this.isEmpty(this.verifyCampaignSellout) === false && this.isEmpty(this.verifyCampaignLoyalty) === true) {
      console.log('tuan', 1)
      bodyDistribute = [
        {
          stampGroups: groupItemsWithType,
          systemType: 0, // 0: sellout, 1: loyalty
          campaignId: this.verifyCampaignSellout.campaignId ? Number(this.verifyCampaignSellout.campaignId) : '',
          campaignCode: this.verifyCampaignSellout.campaignCode ? this.verifyCampaignSellout.campaignCode : '',
          campaignType: this.verifyCampaignSellout.campaignType
        }
      ]
    } else if (this.isEmpty(this.verifyCampaignLoyalty) === false && this.isEmpty(this.verifyCampaignSellout) === true) {
      console.log('tuan', 2)
      bodyDistribute = [
        {
          stampGroups: groupItemsWithType,
          systemType: 1,
          campaignId: this.verifyCampaignLoyalty.campaignId ? Number(this.verifyCampaignLoyalty.campaignId) : '',
          campaignCode: this.verifyCampaignLoyalty.campaignCode ? this.verifyCampaignLoyalty.campaignCode : '',
          campaignType: this.verifyCampaignLoyalty.campaignType,
          giftCode: this.verifyCampaignLoyalty.giftCode,
          priority: this.verifyCampaignLoyalty.priority,
          applyScan: this.applyScan === '' ? '' : Number(this.applyScan),
        }
      ]
    } else if (this.isEmpty(this.verifyCampaignSellout) === false && this.isEmpty(this.verifyCampaignLoyalty) === false) {
      console.log('tuan', 3)
      bodyDistribute = [
        {
          stampGroups: groupItemsWithType,
          systemType: 0, // 0: sellout, 1: loyalty
          campaignId: this.verifyCampaignSellout.campaignId ? Number(this.verifyCampaignSellout.campaignId) : '',
          campaignCode: this.verifyCampaignSellout.campaignCode ? this.verifyCampaignSellout.campaignCode : '',
          campaignType: this.verifyCampaignSellout.campaignType
        },
        {
          stampGroups: groupItemsWithType,
          systemType: 1,
          campaignId: this.verifyCampaignLoyalty.campaignId ? Number(this.verifyCampaignLoyalty.campaignId) : '',
          campaignCode: this.verifyCampaignLoyalty.campaignCode ? this.verifyCampaignLoyalty.campaignCode : '',
          campaignType: this.verifyCampaignLoyalty.campaignType,
          giftCode: this.verifyCampaignLoyalty.giftCode,
          priority: this.verifyCampaignLoyalty.priority,
          applyScan: this.applyScan === '' ? '' : Number(this.applyScan),
        }
      ]
    }
    console.log('body-dis', bodyDistribute);

    if (this.activeTab === 1) {
      clickTracking('qcheck_stamp_distribute', 'btn_distribute_routing', 'qcheck_distribute_history', 'agency');
      const distributionAgent = $('.distributionAgent1');
      const basicMultiple = $('.js-example-basic-multiple');
      // console.log(distributionAgent.val())
      if (distributionAgent.val() === null) {
        this.toastr.warning(this.translateService.instant('BAN_CHUA_CHON_DAI_LY_PHAN_PHOI'), this.translateService.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
        return;
      }
      const listLocationResult = [];
      this.listLocationNew.map((res, index) => {
        const objListLocationResult = {
          provinceId: '',
          districtIds: [],
          wardIds: [],
          address: '',
        };
        objListLocationResult.provinceId = $(`#area_new-${index}`).val();
        objListLocationResult.districtIds = $(`#area_new_district-${index}`).val() || [];
        listLocationResult.push(objListLocationResult)
      })
      const itemBody = {
        provinceIds: [],
        districtIds: [],
        wardIds: [],
        address: [],
      }
      console.log('listLocationResult', listLocationResult);
      if (listLocationResult.length > 0) {
        listLocationResult.map((res) => {
          if (res.provinceId != '') {
            itemBody.provinceIds.push(res.provinceId);
          }
          if (res.address != '') {
            itemBody.address.push(res.address);
          }
          const arr = itemBody.districtIds.concat(res.districtIds);
          itemBody.districtIds = arr
        })
      }
      body = {
        transferLocationAll: basicMultiple.val() === null ? true : false,
        type: this.formCratingBatch.value.is_cratingStamps === 'cratingStampsSingle' ? 0 : 1,
        applyType: 0,
        toAgencyId: parseInt(distributionAgent.val()),
        location: {
          item: itemBody,
          itemV1: listLocationResult
        },
        // applyLocation: this.formCratingBatch.value.is_apply === true ? 1 : 0,
        requiredAccept: this.formCratingBatch.value.is_request === true ? 1 : 0,
        routing: this.formCratingBatch.value.is_routingTypeDistribution == 'routing2' ? true : false,
        name: this.formCratingBatch.value.name && this.formCratingBatch.value.name.trim() !== '' ? this.formCratingBatch.value.name : null,
        note: this.formCratingBatch.value.note && this.formCratingBatch.value.note.trim() != '' ? this.formCratingBatch.value.note : null,
        group: {
          items: groupItemsWithType,
        },
        document: {
          items: this.listImageDistribution && this.listImageDistribution.length ? this.listImageDistribution : null,
        },
      };
      console.log('bodyyy....', body)
      this.distriButionAgencyTextStep3 = $('.distributionAgent1 option:selected').text().trim();
    } else {
      const listLocationResultTab2 = []
      const listLocationResultTab2TextStep3 = [];
      this.listLocationNewTab2.map((res, index) => {
        const objListLocationResult = {
          provinceId: '',
          districtIds: [],
          wardIds: [],
          address: '',
        };
        const tmp = {
          provinceName: '',
          districtNames: [],
        }
        objListLocationResult.provinceId = $(`#area_new_tab2-${index}`).val() || [];
        objListLocationResult.districtIds = $(`#area_new_district_tab2-${index}`).val() || [];
        objListLocationResult.address = $(`#area_new_address_tab2-${index}`).val();
        tmp.provinceName = $(`#area_new_tab2-${index} option:selected`).text().trim() || [];
        tmp.districtNames = $(`#area_new_district_tab2-${index} option:selected`).text().trim() || []
        listLocationResultTab2.push(objListLocationResult)
        listLocationResultTab2TextStep3.push(tmp)
      })
      const itemBodyTab2 = {
        provinceIds: [],
        districtIds: [],
        wardIds: [],
        address: [],
      }
      if (listLocationResultTab2.length > 0) {
        listLocationResultTab2.map((res) => {
          itemBodyTab2.provinceIds.push(res.provinceId);
          itemBodyTab2.address.push(res.address);
          const arr = itemBodyTab2.districtIds.concat(res.districtIds);
          itemBodyTab2.districtIds = arr
        })
      }
      clickTracking('qcheck_stamp_distribute', 'btn_distribute_routing', 'qcheck_distribute_history', 'city');
      body = {
        transferLocationAll: false,
        type: this.formCratingBatch.value.is_cratingStamps === 'cratingStampsSingle' ? 0 : 1,
        applyType: 1,
        toAgencyId: null,
        routing: this.formCratingBatch.value.is_routingTypeDistribution == 'routing2' ? true : false,
        location: {
          item: itemBodyTab2,
          itemV1: listLocationResultTab2
        },
        applyLocation: null,
        requiredAccept: this.formCratingBatch.value.is_request === true && this.activeTab == 1 ? 1 : 0,
        name: this.formCratingBatch.value.name && this.formCratingBatch.value.name.trim() !== '' ? this.formCratingBatch.value.name : null,
        note: this.formCratingBatch.value.note && this.formCratingBatch.value.note.trim() !== '' ? this.formCratingBatch.value.note : null,
        group: {
          items: groupItemsWithType,
        },
        document: {
          items: this.listImageDistribution && this.listImageDistribution.length ? this.listImageDistribution : null,
        },
      };
      this.distriButionAgencyTextStep3 = body.agencyId;
      this.distriButionLocationStep3 = listLocationResultTab2TextStep3
    }

    console.log('body22222', body)
    this.boxStampDistributionService.transferStamp(body).subscribe(
      (res) => {
        // console.log(111);
        //transfer_type	int// 0: không định tuyến// 1: định tuyến
        // transfer_verify_type // 0: có yêu cầu // 1: không yêu cầu
        if (res.code === 1) {
          console.log('this.distriButionAgencyTextStep3', this.distriButionAgencyTextStep3, this.distriButionLocationStep3)
          this.step = 3;
          this.toastr.success(this.translateService.instant('CAP_NHAT_THANH_CONG_2'), this.translateService.instant('THONG_BAO'), {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
          this.disableSubmitFormConfirm = false
          this.clearErrorStamp();
          this.stampList = [];
          this.stampListCodeList = [];
          this.number_stamp_success = res.data.number_stamp_success;
          this.number_stamp_fail = res.data.number_stamp_fail;
          this.arrayStampSuccesExceed = [];
          this.countStampSuccess = 0;
          this.listContent = [];
          // this.getTypeDistribution();
          // this.resetSubmitLocation();
          // this.loadDataParent.emit(true);
        } else {
          this.toastr.warning(res.message, 'Cảnh báo', {
            timeOut: 3000,
            positionClass: 'toast-top-right',
          });
        }
      },
      () => {
        // this.disableSubmitFormConfirm = false
        this.toastr.warning(this.translateService.instant('DA_CO_LOI_XAY_RA_2'), this.translateService.instant('CANH_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right',
        });
      }
    );
    //   } else {
    //     this.boxStampDistributionService.transferStamp(body).subscribe(
    //       (res) => {
    //         // console.log(111);
    //         if (res.code === 1) {
    //           this.step = 1;
    //           this.toastr.success('Cập nhật thành công', 'Thông báo', {
    //             timeOut: 3000,
    //             positionClass: 'toast-top-right',
    //           });
    //           // this.disableSubmitFormConfirm = false
    //           this.reset(this.formCratingBatch.value.is_cratingStamps);
    //           this.resetSubmitLocation();
    //           this.loadDataParent.emit(true);
    //         } else {
    //           this.toastr.warning(res.message, 'Cảnh báo', {
    //             timeOut: 3000,
    //             positionClass: 'toast-top-right',
    //           });
    //         }
    //       },
    //       () => {
    //         // this.disableSubmitFormConfirm = false
    //         this.toastr.warning('Đã có lỗi sảy ra', 'Cảnh báo', {
    //           timeOut: 3000,
    //           positionClass: 'toast-top-right',
    //         });
    //       }
    //     );
    //   }
    // });
    // }
  }

  submitSelectBatchStamp() {
    const totalStamp = this.successListStamp.length + this.successCodeListStamp.length;
    const maxSize = this.max_quantity;
    const maxStampInput = maxSize - totalStamp
    if (totalStamp > maxSize) {
      $('#warningStamp').modal('show');
      return
    }
    if (maxStampInput <= 0) {
      $('#warningStamp').modal('show');
      return
    } else {
      const serial = $('#slt-batchstamp_id').select2('val');
      if (serial) {
        console.log('serial;ádasd', serial)
        const prefix = serial.split('|')[0];
        const serialFirst = serial.split('|')[1];
        const serialLast = serial.split('|')[2];
        console.log(serial);
        const stamp2 = {
          prefix: prefix,
          idStart: serialFirst,
          idEnd: serialLast,
        };
        if (stamp2.idStart == stamp2.idEnd) {
          this.addStampSingle('select-batch', stamp2)
        } else {
          this.addStampCodeList('select-batch', stamp2)
        }
        console.log(this.listContentStampCodeList)
      }
    }
    $('.slt-batchstamp').val(null).trigger('change');
  }

  loadCampaignSellout() {
    const query = {
      page: this.pageIndex,
      pageSize: this.page_size,
      systemType: 0
    }
    this.boxStampDistributionService.getListCampaignSellout(query).subscribe(
      (res) => {
        if (res.code === 1) {
          this.total_data_campaign = res.data.pagination.totalElements;
          const list: any = [];
          for (const _data of res.data.items) {
            const obj = {
              id: _data.id,
              name: _data.name,
              image: this.imageService.readSrcImage(_data.image, 'thumb_large'),
              status: _data.status,
              idEnd: _data.idEnd,
              statusTitle: _data.statusTitle,
              start: _data.start,
              end: _data.end,
              approved: _data.approved,

            };
            list.push(obj);
          }
          ;
          this.data_campaign = list
          console.log(this.has_data_campaign);
          if (list.length > 0) {
            this.has_data_campaign = true;
          } else {
            this.has_data_campaign = false;
          }
        } else {
          this.errorMessage = res.message;
        }
        (err) => {
          console.log(err)
        }
      }
    )
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  acceptCodeSellout() {
    if (this.checkSelectCampain == 1) {
      console.log('list', this.listOfChecked)
      if (this.listOfChecked === '') {
        this.toastr.warning(this.translateService.instant('KHONG_DUOC_DE_TRONG_CHUONG_TRINH'), this.translateService.instant('THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right'
        })
        return;
      } else {
        this.codeCampaignSellout = null;
        this.verifyCampaignSellout = {
          approved: this.myCampaign[6],
          end: this.myCampaign[1],
          campaignId: this.myCampaign[0],
          image: this.myCampaign[5],
          name: this.myCampaign[3],
          start: this.myCampaign[2],
          status: this.myCampaign[4],
          campaignType: 0
        };
        this.campaignCode = null;
        this.listOfChecked = '';
        this.isActiveCampaignSellout = false;
        this.myCampaign = null;
        this.resetSellout();
        this.isActiveCampaignLoyalty = false;
        this.resetLoyalty()
        $('#program').modal('hide');
        console.log('Tuanday', this.verifyCampaignSellout)
      }
    } else if (this.checkSelectCampain == 2) {
      if (!this.campaignCode) {
        this.toastr.warning(this.translateService.instant('KHONG_DUOC_DE_TRONG_MA_CHIEN_DICH'), this.translateService.instant('THONG_BAO'), {
          timeOut: 3000,
          positionClass: 'toast-top-right'
        })
        return;
      }
      const query = {
        code: this.campaignCode
      }

      this.boxStampDistributionService.getDetailCodeSellout(query).subscribe(
        (res) => {
          if (res.code === 1) {
            this.codeCampaignSellout = res.data;
            this.codeCampaignSellout.campaignCode = this.campaignCode;
            this.codeCampaignSellout.campaignType = 1;
            this.listOfChecked = '';
            this.myCampaign = null;
            this.verifyCampaignSellout = this.codeCampaignSellout;
            this.isActiveCampaignSellout = false;
            this.resetSellout();
            this.isActiveCampaignLoyalty = false;
            this.resetLoyalty();
            $('#program').modal('hide');
            console.log('confirm', this.codeCampaignSellout)
          } else {
            this.toastr.warning(res.message, 'Cảnh báo', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }
          (err) => {
            console.log(err)
          }
        }
      )
    } else {
      this.toastr.warning(this.translateService.instant('VUI_LONG_GAN_IT_NHAT_1_CHUONG_TRINH'), this.translateService.instant('THONG_BAO'), {
        timeOut: 3000,
        positionClass: 'toast-top-right'
      })
    }

  }

  radioBoxChange(event) {
    this.listOfChecked = event.target.value;
    console.log('tuanba: ' + this.listOfChecked);
  }

  confirmCampaign() {
    this.modalRef.hide()
    this.myCampaign = this.listOfChecked.split(',');
    this.isCampaign = true;
    // this.codeCampaignSellout = null;
    // this.campaignCode = null
    console.log(typeof (this.myCampaign));
    this.isActiveCampaignSellout = true;
    // this.hideModalProgram();
  }

  showModalListLoyalty(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
    console.log('ct khac', this.listOfCheckedLoyalty);
    this.pageIndex_loyalty = 1;
    this.loadCampaignLoyalty()
  }

  loadCampaignLoyalty() {
    const query = {
      page: this.pageIndex_loyalty,
      pageSize: this.page_size_loyalty,
      systemType: 1
    }
    this.boxStampDistributionService.getListCampaignLoyalty(query).subscribe(
      (res) => {
        if (res.code === 1) {
          this.total_data_campaign_loyalty = res.data.pagination.totalElements;
          const list: any = [];
          for (const _data of res.data.items) {
            const obj = {
              id: _data.id,
              name: _data.name,
              image: this.imageService.readSrcImage(_data.image, 'thumb_large'),
              status: _data.status,
              idEnd: _data.idEnd,
              statusTitle: _data.statusTitle,
              start: _data.start,
              end: _data.end,
              approved: _data.approved,
            };
            list.push(obj);
          }
          ;
          this.data_campaign_loyalty = list
          console.log(this.has_data_campaign_loyalty);
          if (list.length > 0) {
            this.has_data_campaign_loyalty = true;
          } else {
            this.has_data_campaign_loyalty = false;
          }
        } else {
          this.errorMessageLoyalty = res.message;
        }
        (err) => {
          console.log(err)
        }
      }
    )
  }

  acceptCodeLoyalty() {
    if (this.checkSelectCampainLoyalty == 1) {
      if (this.listOfCheckedLoyalty === '') {
        this.toastr.warning('Không được để trống chương trình', 'Thông báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right'
        })
        return;
      } else {
        this.codeCampaignLoyalty = null;
        // if (this.changeService === 0) {
        //   this.priority = 0,
        //     this.applyScan = "";
        // }
        this.verifyCampaignLoyalty = {
          approved: this.myCampaignLoyalty[6],
          end: this.myCampaignLoyalty[1],
          campaignId: this.myCampaignLoyalty[0],
          image: this.myCampaignLoyalty[5],
          name: this.myCampaignLoyalty[3],
          start: this.myCampaignLoyalty[2],
          status: this.myCampaignLoyalty[4],
          campaignType: 0,
          giftCode: this.giftCode,
          priority: this.priority,
          applyScan: this.applyScan
        };
        // this.verifyCampaignLoyalty = this.myCampaignLoyalty;
        this.campaignCodeLoyalty = null;
        this.isActiveCampaignLoyalty = false;
        this.listOfCheckedLoyalty = '';
        this.myCampaignLoyalty = null;
        this.resetLoyalty();
        this.isActiveCampaignSellout = false;
        this.resetSellout();
        $('#program').modal('hide');
      }
    }
    // tslint:disable-next-line:one-line
    else if (this.checkSelectCampainLoyalty == 2) {
      if (!this.campaignCodeLoyalty) {
        this.toastr.warning('Không được để trống mã chiến dịch', 'Thông báo', {
          timeOut: 3000,
          positionClass: 'toast-top-right'
        })
        return;
      }
      const query = {
        code: this.campaignCodeLoyalty
      }
      // if (this.changeService === 0) {
      //   this.priority = 0
      //   this.applyScan = "";
      // }
      this.boxStampDistributionService.getDetailCodeLoyalty(query).subscribe(
        (res) => {
          if (res.code === 1) {
            this.codeCampaignLoyalty = res.data,
              this.codeCampaignLoyalty.campaignCode = this.campaignCodeLoyalty;
            this.codeCampaignLoyalty.giftCode = this.giftCode;
            this.codeCampaignLoyalty.priority = this.priority;
            this.codeCampaignLoyalty.applyScan = this.applyScan;
            this.codeCampaignLoyalty.campaignType = 1;
            this.listOfCheckedLoyalty = '';
            this.myCampaignLoyalty = null;
            this.verifyCampaignLoyalty = this.codeCampaignLoyalty;
            this.isActiveCampaignLoyalty = false;
            this.resetLoyalty();
            this.isActiveCampaignSellout = false;
            this.resetSellout();
            $('#program').modal('hide');
            console.log('confirm-loyalty', this.listOfCheckedLoyalty, this.myCampaignLoyalty)
          } else {
            this.toastr.warning(res.message, 'Cảnh báo', {
              timeOut: 3000,
              positionClass: 'toast-top-right',
            });
          }
          (err) => {
            console.log(err)
          }
        }
      )
    } else {
      this.toastr.warning('Vui lòng chọn ít nhất một chương trình', 'Cảnh báo', {
        timeOut: 3000,
        positionClass: 'toast-top-right',
      });
    }
  }

  removeCampaignLoyalty() {
    this.myCampaignLoyalty = null;
    this.verifyCampaignLoyalty = null;
    this.codeCampaignLoyalty = null;
    this.resetLoyalty();
  }

  prePageListLoyalty() {
    if (this.pageIndex_loyalty > 1) {
      this.pageIndex_loyalty = this.pageIndex_loyalty - 1;
      // this.loading_left = true;
      this.loadCampaignLoyalty();
    }
  }

  lastPageListLoyalty() {
    // console.log('res.items', this.pageIndex * this.page_size, this.total_data )
    // if (this.pageIndex * this.page_size < this.total_data) {
    this.pageIndex_loyalty = this.pageIndex_loyalty + 1;
    // this.loading_left = true;
    this.loadCampaignLoyalty();
    // }
  }

  inputPageListLoyalty(event) {
    // tslint:disable-next-line:radix
    const page = parseInt(event.target.value);
    if (page % 1 === 0 && page > 0 && page !== this.pageIndex) {
      this.pageIndex_loyalty = page;
      // this.loading_left = true;
      this.loadCampaignLoyalty();
    }
  }

  radioBoxChangeService(event) {
    this.applyScan = Number(event.target.value);
    console.log('applycasnevent', typeof (this.applyScan))
  }

  onChangeService() {
    this.changeService = 1; // 0 la ko gửi gì, 1 là chọn apply scan, 2 là chọn bảo hảnh
    this.changeIdetification = false
    this.changeOverflow = false;
    this.applyScan = 0;
    this.priority = 1;
    console.log('applycasn', this.applyScan)
  }

  onChangeIdentification() {
    this.changeIdetification = true;
    this.changeOverflow = false
    this.changeService = 0;
    this.priority = 5;
    this.applyScan = 0;
    console.log('applycasn5', this.applyScan, this.priority)
  }

  onChangeOverflow() {
    this.changeOverflow = true
    this.changeIdetification = false;
    this.changeService = 0;
    this.priority = 3;
    this.applyScan = 0;
    console.log('applycasngua3', this.applyScan, this.priority)
  }

  radioBoxChangeIdentification(event) {
    this.applyScan = Number(event.target.value);
  }

  radioBoxChangeOverflow(event) {
    this.applyScan = Number(event.target.value);
  }

  onChangeGuarantee() {
    $('#scan').modal('show');
    this.changeService = 2;
    this.changeIdetification = false;
    this.priority = 2;
    this.applyScan = null;
    console.log('applycasngua', this.applyScan)
  }

  closeGuarantee() {
    $('#scan').modal('hide');
    this.priority = 0;
    this.applyScan = '';
    $('input[name="scan"]').attr('checked', false);
  }

  confirmGuarantee() {
    this.priority = 2;
    this.applyScan = '';
    console.log('priorytyt', this.priority);
    $('#scan').modal('hide');
  }

  radioBoxChangeLoyalty(event) {
    this.listOfCheckedLoyalty = event.target.value;
    console.log('tuanba: ' + this.listOfCheckedLoyalty);
  }

  onMyCampaignLoyalty() {
    this.checkSelectCampainLoyalty = 1;
    this.campaignCodeLoyalty = null
    if (this.listOfCheckedLoyalty !== '') {
      this.myCampaignLoyalty = this.listOfCheckedLoyalty.split(',');
      console.log(this.myCampaignLoyalty);
    }
  }

  onOtherCampaignLoyalty() {
    this.checkSelectCampainLoyalty = 2;
    this.isCampaignLoyalty = false
  }

  confirmCampaignLoyalty() {
    this.myCampaignLoyalty = this.listOfCheckedLoyalty.split(',');
    this.isCampaignLoyalty = true;
    this.modalRef.hide();
    console.log(typeof (this.myCampaignLoyalty));
    this.isActiveCampaignLoyalty = true;
  }

  closeModalCampaignLoyalty() {
    console.log('tuanba', this.listOfCheckedLoyalty)
    if (!this.myCampaignLoyalty) {
      this.listOfCheckedLoyalty = '';
    }
    this.modalRef.hide();
    this.pageIndex_loyalty = 1;
  }

  /**[1-11-2022: Tuanba]- Locaiton tab 1 Đại ly **/
  getDistrictNew(id: number, type: string, index: any) {
    const query = {
      city_id: id,
    };
    this.addressService.getDistrict(query).subscribe(
      (res) => {
        if (res.status === 200) {
          const citiesListNew = [];
          const items = res.data.districts;
          items.map((item) => {
            citiesListNew.push({
              label: item.name,
              id: item.id,
            });
          });
          if (type === 'district_modal_new') {
            this.listLocationNew[index].districtIdsItems = citiesListNew
          }
          return;
        }
        if (type === 'district_modal_new') {
          this.district_modal_new = [];
        }
      },
      (error) => {
        if (type === 'district_modal_new') {
          this.district_modal_new = [];
        }
      }
    );
  }

  addListLocation() {
    const item = {
      'provinceId': '',
      'districtIds': [],
      'districtIdsItems': [],
      'wardIds': [],
      'address': '',
    }
    this.listLocationNew.push(item);
    console.log('asdasdasd', this.listLocationNew)
    const length = this.listLocationNew.length - 1
    const area_new = `area_new-${this.listLocationNew.length - 1}`
    const area_new_district = `area_new_district-${this.listLocationNew.length - 1}`
    setTimeout(() => {
      $(`#${area_new}`).select2({
        placeholder: this.translateService.instant('CHON_TINH_THANH_1'),
      });
      $(`#${area_new_district}`).select2({
        placeholder: this.translateService.instant('CHON_QUAN_HUYEN_1'),
        allowClear: true,
      });
      const that = this
      $(`#${area_new}`).on('select2:select', function (e) {
        $('.select2-selection__rendered').removeAttr('title');
        const id = e.target.value;
        that.getDistrictNew(id, 'district_modal_new', length);
      });
    }, 0)
  }

  removeListLocation(i: number) {
    this.listLocationNew = this.listLocationNew.filter((res, k) => {
      return i !== k;
    })
  }

  async getFromArea() {
    return await this.addressService.getCities().toPromise();
  }

  async openListLocationNew() {
    await this.getFromArea().then((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.citiesNews = citiesList;
    });
  }

  /**[1-11-2022: Tuanba]- Locaiton tab 2 khu vực **/
  getDistrictNewTab2(id: number, type: string, index: any) {
    const query = {
      city_id: id,
    };
    this.addressService.getDistrict(query).subscribe(
      (res) => {
        if (res.status === 200) {
          const citiesListNew = [];
          const items = res.data.districts;
          items.map((item) => {
            citiesListNew.push({
              label: item.name,
              id: item.id,
            });
          });
          if (type === 'district_modal_new') {
            this.listLocationNewTab2[index].districtIdsItems = citiesListNew
          }
          return;
        }
        if (type === 'district_modal_new') {
          this.district_modal_new_tab2 = [];
        }
      },
      (error) => {
        if (type === 'district_modal_new') {
          this.district_modal_new_tab2 = [];
        }
      }
    );
  }

  addListLocationTab2() {
    // const count = 0;
    const itemTab2 = {
      'provinceId': '',
      'districtIds': [],
      'districtIdsItems': [],
      'wardIds': [],
      'address': '',
    }
    this.listLocationNewTab2.push(itemTab2);
    const length = this.listLocationNewTab2.length - 1
    const area_new_tab2 = `area_new_tab2-${this.listLocationNewTab2.length - 1}`
    const area_new_district_tab2 = `area_new_district_tab2-${this.listLocationNewTab2.length - 1}`
    const area_new_address_tab2 = `area_new_address_tab2-${this.listLocationNewTab2.length - 1}`
    setTimeout(() => {
      $(`#${area_new_tab2}`).select2({
        placeholder: this.translateService.instant('CHON_TINH_THANH_1'),
      });
      $(`#${area_new_district_tab2}`).select2({
        placeholder: this.translateService.instant('CHON_QUAN_HUYEN_1'),
        allowClear: true,
      });
      $(`#${area_new_address_tab2}`).prop('disabled', true);
      const that = this
      $(`#${area_new_tab2}`).on('select2:select', function (e) {
        $('.select2-selection__rendered').removeAttr('title');
        const id = e.target.value;
        that.getDistrictNewTab2(id, 'district_modal_new', length);
        $(`#${area_new_address_tab2}`).val('').change();
        $(`#${area_new_address_tab2}`).prop('disabled', true);
      });
      $(`#${area_new_district_tab2}`).on('select2:close', function (e) {
        const $select = $(this);
        const numSelected = $select.select2('data').length;
        if (numSelected > 1) {
          $(`#${area_new_address_tab2}`).val('').change();
          $(`#${area_new_address_tab2}`).prop('disabled', true);
          console.log('numSelected', numSelected);
        } else if (numSelected == 0) {
          $(`#${area_new_address_tab2}`).val('').change();
          $(`#${area_new_address_tab2}`).prop('disabled', true);
        } else {
          $(`#${area_new_address_tab2}`).prop('disabled', false);
        }
      });
    }, 0)
  }

  removeListLocationTab2(i: number) {
    this.listLocationNewTab2 = this.listLocationNewTab2.filter((res, k) => {
      return i !== k;
    })
  }

  async openListLocationNewTab2() {
    await this.getFromArea().then((res) => {
      const citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.citiesNewsTab2 = citiesList;
    });
  }

  resetSubmitLocation() {
    this.citiesNewsTab2 = [];
    this.citiesNews = [];
    this.listLocationNew = [];
    this.listLocationNewTab2 = [];
  }

  /** Thay đổi giao diện phân phối **/

  addStampCodeList(device: any, data: any) {
    const totalStamp = this.successListStamp.length + this.successCodeListStamp.length;
    const maxSize = this.max_quantity;
    const maxStampInput = maxSize - totalStamp
    console.log('totalStamp', totalStamp)
    if (totalStamp >= maxSize) {
      $('#warningStamp').modal('show');
      return;
    }
    if ((maxSize - totalStamp) <= 0) {
      $('#warningStamp').modal('show');
      return;
    } else {
      if (maxStampInput >= 0) {
        console.log(this.formCratingBatch.get('stampCodeList'))
        const tmp = this.formCratingBatch.value.stampCodeList;
        let stamp
        let tmpListStamp = []
        if (device == 'none') {
          stamp = {
            prefix: tmp.prefixStampList.toUpperCase(),
            idStart: tmp.serialFirstStampList,
            idEnd: tmp.serialLastStampList,
            errorMessage: ''
          };
          tmpListStamp.push(stamp)
          if (stamp.prefix != '') {
            if (parseInt(stamp.idStart) > parseInt(stamp.idEnd)) {
              this.errorStampCodeListInput = 'Serial đầu phải bé hơn serial cuối'
              this.formCratingBatch.get('stampCodeList').setValue({
                prefixStampList: '',
                serialFirstStampList: '',
                serialLastStampList: ''
              })
              return;
            }
          }
        } else if (device == 'scan') {
          stamp = data;
          console.log('data stamp', stamp)
          tmpListStamp.push(stamp)
        } else if (device == 'select-batch') {
          tmpListStamp.push(data)
        } else {
          tmpListStamp = data
        }

        const mergeStampResult = [...this.successListStamp];
        const mergeStampListResult = [...this.errorCodeListStamp, ...this.successCodeListStamp];
        /** Validate các tem gửi lên **/
        if (mergeStampListResult.length > 0 && mergeStampResult.length == 0) {
          const resultTemp = this.getDifference(tmpListStamp, mergeStampListResult);
          /**Check tem trong dai gui len**/
          const resultTemp2 = this.getDifference2(resultTemp, mergeStampListResult);
          console.log('resultTemp2', resultTemp2)
          if (resultTemp2.length > 0) {
            resultTemp2.map((res) => {
              res.errorMessage = 'Đã nằm trong dải tem gửi lên'
              this.errorCodeListStamp.push(res)
            })
          }
          /**Check tem thoa man **/
          const resultTemp3 = this.getDifference3(resultTemp, mergeStampListResult);
          console.log('resultTemp3', resultTemp3)
          if (resultTemp3.length > 0) {
            resultTemp3.map((res) => {
              this.stampListCodeList.push(res)
            })
          }
          console.log('resultTemp22', resultTemp2, resultTemp3);
        } else if (mergeStampListResult.length == 0 && mergeStampResult.length == 0) {
          this.stampListCodeList = tmpListStamp
        } else if (mergeStampListResult.length == 0 && mergeStampResult.length > 0) {
          /**Check tem trong dai gui len**/
          const resultTemp = this.getDifference2(tmpListStamp, mergeStampResult);
          if (resultTemp.length > 0) {
            resultTemp.map((res) => {
              res.errorMessage = 'Đã nằm trong dải tem gửi lên'
              this.errorCodeListStamp.push(res)
            })
          }
          /**Check tem thoa man **/
          const resultTemp2 = this.getDifference3(tmpListStamp, mergeStampResult);
          if (resultTemp2.length > 0) {
            resultTemp2.map((res) => {
              this.stampListCodeList.push(res)
            })
          }
          console.log('resultTemp22', resultTemp, resultTemp2);
        } else if (mergeStampListResult.length > 0 && mergeStampResult.length > 0) {
          const resultTemp = this.getDifference(tmpListStamp, mergeStampResult);
          /**Check tem trong dai gui len**/
          const resultTemp2 = this.getDifference2(resultTemp, mergeStampResult);
          if (resultTemp2.length > 0) {
            resultTemp2.map((res) => {
              res.errorMessage = 'Đã nằm trong dải tem gửi lên'
              this.errorCodeListStamp.push(res)
            })
          }
          /**Check tem thoa man **/
          const resultTemp3 = this.getDifference3(resultTemp, mergeStampResult);
          if (resultTemp3.length > 0) {
            resultTemp3.map((res) => {
              this.stampListCodeList.push(res)
            })
          }
          console.log('resultTemp22', resultTemp2, resultTemp3);
        }
        this.formCratingBatch.get('stampCodeList').setValue({
          prefixStampList: '',
          serialFirstStampList: '',
          serialLastStampList: ''
        })
        this.validateSingleStampNew('list').then(r => console.log('r', r))
        // this.stampListCodeList = this.stampListCodeList.reduce((acc, current) => {
        //   const x = acc.find(item => item.prefix.trim() == current.prefix.trim() && item.idStart.trim() == current.idStart.trim() &&
        //     item.idEnd.trim() == current.idEnd.trim());
        //   if (!x) {
        //     return acc.concat([current]);
        //   } else {
        //     return acc;
        //   }
        // }, []);
      }
    }
  }

  addStampSingle(device: any, data: any) {
    const totalStamp = this.successListStamp.length + this.successCodeListStamp.length;
    const maxSize = this.max_quantity;
    const maxStampInput = maxSize - totalStamp
    if (totalStamp > maxSize) {
      $('#warningStamp').modal('show');
      return
    }
    if (maxStampInput <= 0) {
      $('#warningStamp').modal('show');
      return
    } else {
      let e;
      const tmpSingleStamp = []
      if (device == 'none') {
        e = this.addContent.toUpperCase().split('\n');
      } else if (device == 'scan') {
        e = Array.isArray(data) ? data : data.toUpperCase().split('\n');
      } else if (device == 'select-batch') {
        tmpSingleStamp.push(data)
      } else {
        console.log('checkasdasd', data)
        e = data
      }

      console.log('e', e, maxStampInput)
      if (maxStampInput >= e.length) {
        e.map((res) => {
          if ((typeof res) != 'object') {
            if (res.trim().length > 0) {
              this.listContent.push(res.trim());
            }
          }
        })
        e.map((res) => {
          console.log('typeof', typeof res)
          if ((typeof res) != 'object') {
            if (res.trim().length > 0) {
              const splitSerial = res.split('-');
              let _serial: any = '';
              let _prefix: any = '';
              if (splitSerial.length > 1) {
                _serial = splitSerial.pop();
                _prefix = splitSerial[0];
              } else {
                _serial = NaN;
                _prefix = splitSerial[0];
              }
              const stamp = {
                prefix: _prefix,
                idStart: _serial,
                idEnd: _serial,
                errorMessage: ''
              };
              tmpSingleStamp.push(stamp)
            }
          } else {
            tmpSingleStamp.push(res);
          }

        });
        const mergeStampListResult = [...this.successCodeListStamp];
        const mergeStampResult = [...this.errorListStamp, ...this.successListStamp];
        /** Validate các tem gửi lên **/
        if (mergeStampResult.length > 0 && mergeStampListResult.length == 0) {
          const resultTemp = this.getDifference(tmpSingleStamp, mergeStampResult);
          this.stampList = resultTemp
        } else if (mergeStampResult.length == 0 && mergeStampListResult.length == 0) {
          this.stampList = tmpSingleStamp
        } else if (mergeStampResult.length == 0 && mergeStampListResult.length > 0) {
          /**Check tem trong dai gui len**/
          const resultTemp2 = this.getDifference2(tmpSingleStamp, mergeStampListResult);
          if (resultTemp2.length > 0) {
            resultTemp2.map((res) => {
              res.errorMessage = 'Đã nằm trong dải tem gửi lên'
              this.errorListStamp.push(res)
            })
          }
          /**Check tem thoa man **/
          const resultTemp3 = this.getDifference3(tmpSingleStamp, mergeStampListResult);
          if (resultTemp3.length > 0) {
            resultTemp3.map((res) => {
              this.stampList.push(res)
            })
          }
        } else if (mergeStampResult.length > 0 && mergeStampListResult.length > 0) {
          const resultTemp = this.getDifference(tmpSingleStamp, mergeStampResult);
          /**Check tem trong dai gui len**/
          const resultTemp2 = this.getDifference2(resultTemp, mergeStampListResult);
          if (resultTemp2.length > 0) {
            resultTemp2.map((res) => {
              res.errorMessage = 'Đã nằm trong dải tem gửi lên'
              this.errorListStamp.push(res)
            })
          }
          /**Check tem thoa man **/
          const resultTemp3 = this.getDifference3(resultTemp, mergeStampListResult);
          if (resultTemp3.length > 0) {
            resultTemp3.map((res) => {
              this.stampList.push(res)
            })
          }
        }
        // // this.stampList = resultTemp
        // this.stampList = this.stampList.filter((res) => {
        //   return res.idStart == res.idEnd
        // })
        // this.stampList = this.stampList.reduce((unique, o) => {
        //   if (!unique.some(obj => obj.prefix === o.prefix && obj.idStart === o.idStart && obj.idEnd === o.idEnd)) {
        //     unique.push(o);
        //   }
        //   return unique;
        // }, []);
        this.addContent = '';
        this.isLoading = true;
        this.validateSingleStampNew('single').then(r => console.log('rrrr', r));

      } else {
        $('#warningStamp').modal('show');
      }

    }
  }

  fillterDuplicate(array) {
    return array.reduce((unique, o) => {
      if (!unique.some(obj => obj.prefix === o.prefix && obj.idStart === o.idStart && obj.idEnd === o.idEnd)) {
        unique.push(o);
      }
      return unique;
    }, []);
  }
  areObjectsEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }


  async validateSingleStampNew(typeStamp: any) {
    const totalStamp = this.successListStamp.length + this.successCodeListStamp.length;
    const maxSize = this.max_quantity;
    const maxStampInput = maxSize - totalStamp
    if (totalStamp > maxSize) {
      $('#warningStamp').modal('show');
      return
    }
    if (maxStampInput <= 0) {
      $('#warningStamp').modal('show');
      return
    } else {
      this.errorStampCodeListInput = '';
      const routing = this.formCratingBatch.value.is_routingTypeDistribution == 'routing2' ? true : false;
      const type = this.formCratingBatch.value.is_cratingStamps;
      console.log('type', type)
      // Check tem lẻ gửi lên
      this.stampList = this.stampList.reduce((unique, o) => {
        if (!unique.some(obj => obj.prefix === o.prefix && obj.idStart === o.idStart && obj.idEnd === o.idEnd)) {
          unique.push(o);
        }
        return unique;
      }, []);
      this.stampListCodeList = this.stampListCodeList.reduce((unique, o) => {
        if (!unique.some(obj => obj.prefix === o.prefix && obj.idStart === o.idStart && obj.idEnd === o.idEnd)) {
          unique.push(o);
        }
        return unique;
      }, []);
      const stampList = this.stampList;
      const stampCodeList = this.stampListCodeList;
      let data = [];
      if (typeStamp == 'single') {
        data = stampList
      } else {
        data = stampCodeList
      }
      console.log('data22222', data);
      const convertValidate = [...data];
      if (convertValidate.length > 0) {
        console.log('convertValidate', convertValidate)
        const validateAPI = [];
        convertValidate.map((res) => {
          if (res.prefix) {
            if (res.prefix.trim() !== '' && res.idStart !== '' && res.idEnd !== '') {
              validateAPI.push({
                prefix: res.prefix.toUpperCase(),
                idStart: res.idStart,
                idEnd: res.idEnd,
              });
            }
          }
        });
        console.log('validare', validateAPI)
        const body = {
          routing: routing,
          group: { items: validateAPI },
          type: type === 'cratingStampsSingle' ? 0 : 1,
          internalCode: this.internalCode,
          internalCodes: this.internalCodes
        };
        if (this.timeout) {
          clearTimeout(this.timeout);
          this.timeout = null;
        }
        const arrStampSingle = [];
        const arrStampCodeList = [];
        // this.timeout = setTimeout(async (val) => {

        if (this.formCratingBatch.value.is_cratingStamps != 'cratingStampBoxProduct') {
          await this.boxStampDistributionService.transferValidate(body).subscribe(
            (res) => {
              console.log('rêsspone', res)
              const tmpRes = res.data.items;
              // let errornull = 0;
              tmpRes.map((val) => {
                if (val.idStart == val.idEnd) {
                  arrStampSingle.push(val)
                } else {
                  arrStampCodeList.push(val)
                }
              })
              if (arrStampSingle.length > 0) {
                arrStampSingle.map((val) => {
                  if (val.errorMessage == null) {
                    this.successListStamp.push(val)
                  } else {
                    this.errorListStamp.push(val)
                  }
                })
              }
              if (arrStampCodeList.length > 0) {
                arrStampCodeList.map((val) => {
                  if (val.errorMessage == null) {
                    this.successCodeListStamp.push(val)
                  } else {
                    this.errorCodeListStamp.push(val)
                  }
                })
              }
              console.log('this.successCodeListStamp', this.successCodeListStamp, 'this.errorCodeListStamp', this.errorCodeListStamp)
              console.log('this.stampList', this.stampList, 'this.listContentStampCodeList', this.listContentStampCodeList)
              console.log('this.successListStamp', this.successListStamp, 'this.errorListStamp', this.errorListStamp)
              console.log('validateAPI', validateAPI)
              /** Check tem thùng **/
              if (type == 'cratingStampsSingle') {
                console.log('vao ko kookokokok')
                /** Gộp 2 mảng thành công check listParent **/
                const mergeSuccesStamp = [...this.successListStamp, ...this.successCodeListStamp]
                console.log('mergeSuccesStamp', mergeSuccesStamp, validateAPI);
                if (mergeSuccesStamp.length > 0) {
                  const check = this.isPrefixInList(validateAPI, mergeSuccesStamp);
                  console.log('check', check)
                  if (check.length > 0) {
                    const fillterArrayResult = this.getDifference4(mergeSuccesStamp, check)
                    console.log('fillterArrayResult', fillterArrayResult)
                    fillterArrayResult.map((res) => {
                      if (res.idStart == res.idEnd) {
                        res.errorMessage = 'Thùng chứa tem đã quét';
                        this.errorListStamp.push(res);
                        this.successListStamp = this.filterArray([res], this.successListStamp)
                      } else {
                        res.errorMessage = 'Thùng chứa tem đã quét';
                        this.errorCodeListStamp.push(res);
                        this.successCodeListStamp = this.filterArray([res], this.successCodeListStamp)
                      }
                    })
                  } else {
                    const fillterArrayResultNextStep = [];
                    /** Lọc phần tử input vs mảng success **/
                    const fillterStampInput = [];
                    for (let i = 0; i < mergeSuccesStamp.length; i++) {
                      for (let j = 0; j < validateAPI.length; j++) {
                        if (mergeSuccesStamp[i].prefix === validateAPI[j].prefix
                          && mergeSuccesStamp[i].idStart == validateAPI[j].idStart
                          && mergeSuccesStamp[i].idEnd == validateAPI[j].idEnd) {
                          fillterStampInput.push(mergeSuccesStamp[i]);
                          break;
                        }
                      }
                    }
                    console.log('result2212', fillterStampInput)
                    /** Kiểm tra input và success **/
                    const listFillterError = []; // khởi tạo biến lưu kết quả tìm được
                    for (let i = 0; i < fillterStampInput.length; i++) { // duyệt qua các phần tử trong mảng a
                      if (fillterStampInput[i].listParent.length > 0) {
                        for (let k = 0; k < fillterStampInput[i].listParent.length; k++) {
                          for (let j = 0; j < mergeSuccesStamp.length; j++) { // duyệt qua các phần tử trong mảng b
                            if (mergeSuccesStamp[j].prefix == fillterStampInput[i].listParent[k].prefix
                              && mergeSuccesStamp[j].idEnd == fillterStampInput[i].listParent[k].number
                              && mergeSuccesStamp[j].idStart == fillterStampInput[i].listParent[k].number) {
                              listFillterError.push(fillterStampInput[i]);
                            }
                          }
                        }
                      }
                    }
                    /** Trả về kết quả **/
                    console.log('fillterArrayResult222', fillterArrayResultNextStep)
                    console.log('successCodeListStamp', this.successCodeListStamp)
                    console.log('successListStamp', this.successListStamp)
                    listFillterError.map((res) => {
                      if (res.idStart == res.idEnd) {
                        res.errorMessage = 'Tem nằm trong thùng đã quét';
                        this.errorListStamp.push(res);
                        this.successListStamp = this.filterArray([res], this.successListStamp)
                      } else {
                        res.errorMessage = 'Tem nằm trong thùng đã quét';
                        this.errorCodeListStamp.push(res);
                        this.successCodeListStamp = this.filterArray([res], this.successCodeListStamp)
                      }
                    })
                  }
                }
              }
              this.stampList = []
              this.stampListCodeList = []
              this.fillterDuplicate(this.successListStamp)
              this.fillterDuplicate(this.errorListStamp)
              this.fillterDuplicate(this.successCodeListStamp)
              this.fillterDuplicate(this.errorCodeListStamp)
            },
            (err) => {
              this.errorMessageStamSingle = err.message ? [err.message] : ['Kiểm tra tem bị lỗi'];
            }
          );
        } else {
          const body = {
            routing: routing,
            qrCode: validateAPI[0].prefix + '-' + validateAPI[0].idStart,
            scanType: 2,
          };
          console.log('this.formCratingBatch.value.is_cratingStamps vao day chu ni')
          await this.boxStampDistributionService.transferValidateNew(body).subscribe(
            (res) => {
              console.log('rêsspone', res)
              const tmpRes = res.data;
              tmpRes.errorMessage = tmpRes.errMsg
              if (tmpRes.idStart == tmpRes.idEnd) {
                arrStampSingle.push(tmpRes)
              }
              if (arrStampSingle.length > 0) {
                arrStampSingle.map((val) => {
                  if (val.errMsg == null) {
                    console.log('vao day ko')
                    this.successListStamp.push(val)
                    this.successListStamp = Array.from(new Set(this.successListStamp.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
                  } else {
                    this.errorListStamp.push(val)
                    this.errorListStamp = Array.from(new Set(this.errorListStamp.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
                  }
                })
              }
              console.log('this.successListStamp', this.successListStamp, 'this.errorListStamp', this.errorListStamp)
              console.log('validateAPI', validateAPI)
              return
              /** Check tem thùng **/
              if (type == 'cratingStampsSingle') {
                console.log('vao ko kookokokok')
                /** Gộp 2 mảng thành công check listParent **/
                const mergeSuccesStamp = [...this.successListStamp, ...this.successCodeListStamp]
                console.log('mergeSuccesStamp', mergeSuccesStamp, validateAPI);
                if (mergeSuccesStamp.length > 0) {
                  const check = this.isPrefixInList(validateAPI, mergeSuccesStamp);
                  console.log('check', check)
                  if (check.length > 0) {
                    const fillterArrayResult = this.getDifference4(mergeSuccesStamp, check)
                    console.log('fillterArrayResult', fillterArrayResult)
                    fillterArrayResult.map((res) => {
                      if (res.idStart == res.idEnd) {
                        res.errorMessage = 'Thùng chứa tem đã quét';
                        this.errorListStamp.push(res);
                        this.successListStamp = this.filterArray([res], this.successListStamp)
                      } else {
                        res.errorMessage = 'Thùng chứa tem đã quét';
                        this.errorCodeListStamp.push(res);
                        this.successCodeListStamp = this.filterArray([res], this.successCodeListStamp)
                      }
                    })
                  } else {
                    const fillterArrayResultNextStep = [];
                    /** Lọc phần tử input vs mảng success **/
                    const fillterStampInput = [];
                    for (let i = 0; i < mergeSuccesStamp.length; i++) {
                      for (let j = 0; j < validateAPI.length; j++) {
                        if (mergeSuccesStamp[i].prefix === validateAPI[j].prefix
                          && mergeSuccesStamp[i].idStart == validateAPI[j].idStart
                          && mergeSuccesStamp[i].idEnd == validateAPI[j].idEnd) {
                          fillterStampInput.push(mergeSuccesStamp[i]);
                          break;
                        }
                      }
                    }
                    console.log('result2212', fillterStampInput)
                    /** Kiểm tra input và success **/
                    const listFillterError = []; // khởi tạo biến lưu kết quả tìm được
                    for (let i = 0; i < fillterStampInput.length; i++) { // duyệt qua các phần tử trong mảng a
                      if (fillterStampInput[i].listParent.length > 0) {
                        for (let k = 0; k < fillterStampInput[i].listParent.length; k++) {
                          for (let j = 0; j < mergeSuccesStamp.length; j++) { // duyệt qua các phần tử trong mảng b
                            if (mergeSuccesStamp[j].prefix == fillterStampInput[i].listParent[k].prefix
                              && mergeSuccesStamp[j].idEnd == fillterStampInput[i].listParent[k].number
                              && mergeSuccesStamp[j].idStart == fillterStampInput[i].listParent[k].number) {
                              listFillterError.push(fillterStampInput[i]);
                            }
                          }
                        }
                      }
                    }
                    /** Trả về kết quả **/
                    console.log('fillterArrayResult222', fillterArrayResultNextStep)
                    console.log('successCodeListStamp', this.successCodeListStamp)
                    console.log('successListStamp', this.successListStamp)
                    listFillterError.map((res) => {
                      if (res.idStart == res.idEnd) {
                        res.errorMessage = 'Tem nằm trong thùng đã quét';
                        this.errorListStamp.push(res);
                        this.successListStamp = this.filterArray([res], this.successListStamp)
                      } else {
                        res.errorMessage = 'Tem nằm trong thùng đã quét';
                        this.errorCodeListStamp.push(res);
                        this.successCodeListStamp = this.filterArray([res], this.successCodeListStamp)
                      }
                    })
                  }
                }
              }
              this.stampList = []
              this.stampListCodeList = []
              this.fillterDuplicate(this.successListStamp)
              this.fillterDuplicate(this.errorListStamp)
              this.fillterDuplicate(this.successCodeListStamp)
              this.fillterDuplicate(this.errorCodeListStamp)
            },
            (err) => {
              this.errorMessageStamSingle = err.message ? [err.message] : [this.translateService.instant('KIEM_TRA_TEM_BI_LOI')];
            }
          );
        }
      }
      // check tem cha - con trùng nhau
      // tem thùng lẻ / dải tem có cha trong dải tem
      // dải tem có cha là đầu/cuối của dải tem khác
      // tem lẻ có cha là tem lẻ khác trong list tem lẻ gửi lên
      // this.stampList = [];
      // this.stampListCodeList = [];
    }
  }
  async validateSingleStampNew2(typeStamp: any) {
    const totalStamp = this.successListStamp.length + this.successCodeListStamp.length;
    const maxSize = this.max_quantity;
    const maxStampInput = maxSize - totalStamp
    if (totalStamp > maxSize) {
      $('#warningStamp').modal('show');
      return
    }
    if (maxStampInput <= 0) {
      $('#warningStamp').modal('show');
      return
    } else {
      this.errorStampCodeListInput = '';
      const routing = this.formCratingBatch.value.is_routingTypeDistribution == 'routing2' ? true : false;
      const type = this.formCratingBatch.value.is_cratingStamps;
      console.log('type', type)
      // Check tem lẻ gửi lên
      this.stampList = this.stampList.reduce((unique, o) => {
        if (!unique.some(obj => obj.prefix === o.prefix && obj.idStart === o.idStart && obj.idEnd === o.idEnd)) {
          unique.push(o);
        }
        return unique;
      }, []);
      this.stampListCodeList = this.stampListCodeList.reduce((unique, o) => {
        if (!unique.some(obj => obj.prefix === o.prefix && obj.idStart === o.idStart && obj.idEnd === o.idEnd)) {
          unique.push(o);
        }
        return unique;
      }, []);
      const stampList = this.stampList;
      const stampCodeList = this.stampListCodeList;
      let data = [];
      if (typeStamp == 'single') {
        data = stampList
      } else {
        data = stampCodeList
      }
      console.log('data22222', data);
      const convertValidate = [...data];
      const validateAPI = [];
      if (true) {
        // console.log('convertValidate', convertValidate)
        // convertValidate.map((res) => {
        //   if (res.prefix) {
        //     if (res.prefix.trim() !== '' && res.idStart !== '' && res.idEnd !== '') {
        //       validateAPI.push({
        //         prefix: res.prefix.toUpperCase(),
        //         idStart: res.idStart,
        //         idEnd: res.idEnd,
        //       });
        //     }
        //   }
        // });
        // console.log('validare', validateAPI)
        const body = {
          routing: routing,
          group: { items: [] },
          type: type === 'cratingStampsSingle' ? 0 : 1,
          internalCode: this.internalCode,
          internalCodes: this.internalCodes
        };
        if (this.timeout) {
          clearTimeout(this.timeout);
          this.timeout = null;
        }
        const arrStampSingle = [];
        const arrStampCodeList = [];
        // this.timeout = setTimeout(async (val) => {

        if (this.formCratingBatch.value.is_cratingStamps != 'cratingStampBoxProduct') {
          await this.boxStampDistributionService.transferValidate(body).subscribe(
            (res) => {
              console.log('rêsspone', res)
              if (res.code === 100) {
                this.toastr.warning(res.message, 'Thông báo:', {
                  timeOut: 3000,
                  positionClass: 'toast-top-right',
                });
                return;
              }
              const tmpRes = res.data.items;
              // let errornull = 0;
              tmpRes.map((val, idx) => {
                // Gắn lại internalCode tương ứng (nếu có) để sau này có thể xóa đúng trong successInternalCodes
                const internalCodeForItem =
                  this.internalCodes && this.internalCodes.length > idx
                    ? this.internalCodes[idx]
                    : null;
                (val as any).__internalCode = internalCodeForItem;
                // if (val.idStart == val.idEnd) {
                arrStampSingle.push(val);
                // } else {
                //   arrStampCodeList.push(val)
                // }
              });
              if (arrStampSingle.length > 0) {
                arrStampSingle.map((val) => {
                  if (val.errorMessage == null) {
                    this.successListStamp.push(val);
                    // Lưu lại internalCode theo từng tem thành công
                    const internalCodeForItem = (val as any).__internalCode;
                    if (internalCodeForItem) {
                      if (!this.successInternalCodes.includes(internalCodeForItem)) {
                        this.successInternalCodes.push(internalCodeForItem);
                      }
                    }
                  } else {
                    this.errorListStamp.push(val);
                  }
                });
              }
              // if (arrStampCodeList.length > 0) {
              //   arrStampCodeList.map((val) => {
              //     if (val.errorMessage == null) {
              //       this.successCodeListStamp.push(val)
              //     } else {
              //       this.errorCodeListStamp.push(val)
              //     }
              //   })
              // }
              console.log('this.successCodeListStamp', this.successCodeListStamp, 'this.errorCodeListStamp', this.errorCodeListStamp)
              console.log('this.stampList', this.stampList, 'this.listContentStampCodeList', this.listContentStampCodeList)
              console.log('this.successListStamp', this.successListStamp, 'this.errorListStamp', this.errorListStamp)
              console.log('validateAPI', validateAPI)
              /** Check tem thùng **/
              // if (type == 'cratingStampsSingle') {
              //   console.log('vao ko kookokokok')
              //   /** Gộp 2 mảng thành công check listParent **/
              //   const mergeSuccesStamp = [...this.successListStamp, ...this.successCodeListStamp]
              //   console.log('mergeSuccesStamp', mergeSuccesStamp, validateAPI);
              //   if (mergeSuccesStamp.length > 0) {
              //     const check = this.isPrefixInList(validateAPI, mergeSuccesStamp);
              //     console.log('check', check)
              //     if (check.length > 0) {
              //       const fillterArrayResult = this.getDifference4(mergeSuccesStamp, check)
              //       console.log('fillterArrayResult', fillterArrayResult)
              //       fillterArrayResult.map((res) => {
              //         if (res.idStart == res.idEnd) {
              //           res.errorMessage = 'Thùng chứa tem đã quét';
              //           this.errorListStamp.push(res);
              //           this.successListStamp = this.filterArray([res], this.successListStamp)
              //         } else {
              //           res.errorMessage = 'Thùng chứa tem đã quét';
              //           this.errorCodeListStamp.push(res);
              //           this.successCodeListStamp = this.filterArray([res], this.successCodeListStamp)
              //         }
              //       })
              //     } else {
              //       const fillterArrayResultNextStep = [];
              //       /** Lọc phần tử input vs mảng success **/
              //       const fillterStampInput = [];
              //       for (let i = 0; i < mergeSuccesStamp.length; i++) {
              //         for (let j = 0; j < validateAPI.length; j++) {
              //           if (mergeSuccesStamp[i].prefix === validateAPI[j].prefix
              //             && mergeSuccesStamp[i].idStart == validateAPI[j].idStart
              //             && mergeSuccesStamp[i].idEnd == validateAPI[j].idEnd) {
              //             fillterStampInput.push(mergeSuccesStamp[i]);
              //             break;
              //           }
              //         }
              //       }
              //       console.log('result2212', fillterStampInput)
              //       /** Kiểm tra input và success **/
              //       const listFillterError = []; // khởi tạo biến lưu kết quả tìm được
              //       for (let i = 0; i < fillterStampInput.length; i++) { // duyệt qua các phần tử trong mảng a
              //         if (fillterStampInput[i].listParent.length > 0) {
              //           for (let k = 0; k < fillterStampInput[i].listParent.length; k++) {
              //             for (let j = 0; j < mergeSuccesStamp.length; j++) { // duyệt qua các phần tử trong mảng b
              //               if (mergeSuccesStamp[j].prefix == fillterStampInput[i].listParent[k].prefix
              //                 && mergeSuccesStamp[j].idEnd == fillterStampInput[i].listParent[k].number
              //                 && mergeSuccesStamp[j].idStart == fillterStampInput[i].listParent[k].number) {
              //                 listFillterError.push(fillterStampInput[i]);
              //               }
              //             }
              //           }
              //         }
              //       }
              //       /** Trả về kết quả **/
              //       console.log('fillterArrayResult222', fillterArrayResultNextStep)
              //       console.log('successCodeListStamp', this.successCodeListStamp)
              //       console.log('successListStamp', this.successListStamp)
              //       listFillterError.map((res) => {
              //         if (res.idStart == res.idEnd) {
              //           res.errorMessage = 'Tem nằm trong thùng đã quét';
              //           this.errorListStamp.push(res);
              //           this.successListStamp = this.filterArray([res], this.successListStamp)
              //         } else {
              //           res.errorMessage = 'Tem nằm trong thùng đã quét';
              //           this.errorCodeListStamp.push(res);
              //           this.successCodeListStamp = this.filterArray([res], this.successCodeListStamp)
              //         }
              //       })
              //     }
              //   }
              // }
              this.stampList = []
              this.stampListCodeList = []
              this.fillterDuplicate(this.successListStamp)
              this.fillterDuplicate(this.errorListStamp)
              this.fillterDuplicate(this.successCodeListStamp)
              this.fillterDuplicate(this.errorCodeListStamp)
            },
            (err) => {
              this.errorMessageStamSingle = err.message ? [err.message] : [this.translateService.instant('KIEM_TRA_TEM_BI_LOI')];
            }
          );
        } else {
          const body = {
            routing: routing,
            qrCode: validateAPI[0].prefix + '-' + validateAPI[0].idStart,
            scanType: 2,
          };
          console.log('this.formCratingBatch.value.is_cratingStamps vao day chu ni')
          await this.boxStampDistributionService.transferValidateNew(body).subscribe(
            (res) => {
              console.log('rêsspone', res)
              const tmpRes = res.data;
              tmpRes.errorMessage = tmpRes.errMsg
              if (tmpRes.idStart == tmpRes.idEnd) {
                arrStampSingle.push(tmpRes)
              }
              if (arrStampSingle.length > 0) {
                arrStampSingle.map((val) => {
                  if (val.errMsg == null) {
                    console.log('vao day ko')
                    this.successListStamp.push(val)
                    this.successListStamp = Array.from(new Set(this.successListStamp.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
                  } else {
                    this.errorListStamp.push(val)
                    this.errorListStamp = Array.from(new Set(this.errorListStamp.map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
                  }
                })
              }
              console.log('this.successListStamp', this.successListStamp, 'this.errorListStamp', this.errorListStamp)
              console.log('validateAPI', validateAPI)
              return
              /** Check tem thùng **/
              if (type == 'cratingStampsSingle') {
                console.log('vao ko kookokokok')
                /** Gộp 2 mảng thành công check listParent **/
                const mergeSuccesStamp = [...this.successListStamp, ...this.successCodeListStamp]
                console.log('mergeSuccesStamp', mergeSuccesStamp, validateAPI);
                if (mergeSuccesStamp.length > 0) {
                  const check = this.isPrefixInList(validateAPI, mergeSuccesStamp);
                  console.log('check', check)
                  if (check.length > 0) {
                    const fillterArrayResult = this.getDifference4(mergeSuccesStamp, check)
                    console.log('fillterArrayResult', fillterArrayResult)
                    fillterArrayResult.map((res) => {
                      if (res.idStart == res.idEnd) {
                        res.errorMessage = 'Thùng chứa tem đã quét';
                        this.errorListStamp.push(res);
                        this.successListStamp = this.filterArray([res], this.successListStamp)
                      } else {
                        res.errorMessage = 'Thùng chứa tem đã quét';
                        this.errorCodeListStamp.push(res);
                        this.successCodeListStamp = this.filterArray([res], this.successCodeListStamp)
                      }
                    })
                  } else {
                    const fillterArrayResultNextStep = [];
                    /** Lọc phần tử input vs mảng success **/
                    const fillterStampInput = [];
                    for (let i = 0; i < mergeSuccesStamp.length; i++) {
                      for (let j = 0; j < validateAPI.length; j++) {
                        if (mergeSuccesStamp[i].prefix === validateAPI[j].prefix
                          && mergeSuccesStamp[i].idStart == validateAPI[j].idStart
                          && mergeSuccesStamp[i].idEnd == validateAPI[j].idEnd) {
                          fillterStampInput.push(mergeSuccesStamp[i]);
                          break;
                        }
                      }
                    }
                    console.log('result2212', fillterStampInput)
                    /** Kiểm tra input và success **/
                    const listFillterError = []; // khởi tạo biến lưu kết quả tìm được
                    for (let i = 0; i < fillterStampInput.length; i++) { // duyệt qua các phần tử trong mảng a
                      if (fillterStampInput[i].listParent.length > 0) {
                        for (let k = 0; k < fillterStampInput[i].listParent.length; k++) {
                          for (let j = 0; j < mergeSuccesStamp.length; j++) { // duyệt qua các phần tử trong mảng b
                            if (mergeSuccesStamp[j].prefix == fillterStampInput[i].listParent[k].prefix
                              && mergeSuccesStamp[j].idEnd == fillterStampInput[i].listParent[k].number
                              && mergeSuccesStamp[j].idStart == fillterStampInput[i].listParent[k].number) {
                              listFillterError.push(fillterStampInput[i]);
                            }
                          }
                        }
                      }
                    }
                    /** Trả về kết quả **/
                    console.log('fillterArrayResult222', fillterArrayResultNextStep)
                    console.log('successCodeListStamp', this.successCodeListStamp)
                    console.log('successListStamp', this.successListStamp)
                    listFillterError.map((res) => {
                      if (res.idStart == res.idEnd) {
                        res.errorMessage = 'Tem nằm trong thùng đã quét';
                        this.errorListStamp.push(res);
                        this.successListStamp = this.filterArray([res], this.successListStamp)
                      } else {
                        res.errorMessage = 'Tem nằm trong thùng đã quét';
                        this.errorCodeListStamp.push(res);
                        this.successCodeListStamp = this.filterArray([res], this.successCodeListStamp)
                      }
                    })
                  }
                }
              }
              this.stampList = []
              this.stampListCodeList = []
              this.fillterDuplicate(this.successListStamp)
              this.fillterDuplicate(this.errorListStamp)
              this.fillterDuplicate(this.successCodeListStamp)
              this.fillterDuplicate(this.errorCodeListStamp)
            },
            (err) => {
              this.errorMessageStamSingle = err.message ? [err.message] : [this.translateService.instant('KIEM_TRA_TEM_BI_LOI')];
            }
          );
        }
      }
      // check tem cha - con trùng nhau
      // tem thùng lẻ / dải tem có cha trong dải tem
      // dải tem có cha là đầu/cuối của dải tem khác
      // tem lẻ có cha là tem lẻ khác trong list tem lẻ gửi lên
      // this.stampList = [];
      // this.stampListCodeList = [];
    }
  }
  isPrefixInList(array1, array2) {
    const arrayErrors = []
    for (let i = 0; i < array1.length; i++) {
      const prefix = array1[i].prefix;
      const idStart = array1[i].idStart;
      const idEnd = array1[i].idEnd;
      for (let j = 0; j < array2.length; j++) {
        const arr2 = array2[j];
        if (arr2.prefix === prefix) {
          for (let k = 0; k < arr2.listParent.length; k++) {
            const parent = arr2.listParent[k];
            if (parent.prefix === prefix && parent.number >= idStart && parent.number <= idEnd) {
              arrayErrors.push(array1[i]);
            }
          }
        }
      }
    }
    return arrayErrors;
  }

  isPrefixInListRevert(array2, array1) {
    const arrayErrors = [];
    for (let i = 0; i < array2.length; i++) {
      for (let k = 0; k < array2[i].listParent.length; k++) {
        const tmp = array2[i].listParent[k];
        for (let j = 0; j < array1.length; j++) {
          if (tmp.prefix == array1[j].prefix && tmp.number >= array1[j].idStart && tmp.number <= array1[j].idEnd) {
            arrayErrors.push(array1[j])
          }
        }
      }
    }
    return arrayErrors;
  }

  filterArray(array1, array2) {
    return array2.filter(item2 => {
      let isDuplicate = false;
      array1.forEach(item1 => {
        if (JSON.stringify(item1) === JSON.stringify(item2)) {
          isDuplicate = true;
        }
      });
      return !isDuplicate;
    });
  }

  getDifference4(array1, array2) {
    return array1.filter(object1 => {
      return array2.some(object2 => {
        return object1.prefix == object2.prefix && object1.idStart == object2.idStart && object1.idEnd == object2.idEnd;
      });
    });
  }

  getDifference(array1, array2) {
    return array1.filter(object1 => {
      return !array2.some(object2 => {
        return object1.prefix == object2.prefix && object1.idStart == object2.idStart && object1.idEnd == object2.idEnd;
      });
    });
  }

  getDifference2(array1, array2) {
    return array1.filter(object1 => {
      return array2.some(object2 => {
        return object1.prefix == object2.prefix && object1.idEnd >= object2.idStart && object1.idStart <= object2.idEnd;
      });
    });
  }

  getDifference3(array1, array2) {
    return array1.filter(object1 => {
      return !array2.some(object2 => {
        return object1.prefix == object2.prefix && object1.idEnd >= object2.idStart && object1.idStart <= object2.idEnd;
      });
    });
  }


  checktemp() {
    console.log('this.stampList1111', this.stampList)
    this.errorMessage = ['Đang kiểm tra...'];
    let data = [];
    if (
      this.formCratingBatch.value.stampCodeList.length > 0 &&
      this.stampList.length > 0
    ) {
      console.log(555667, this.formCratingBatch.value.stampCodeList, this.stampList);

      const tmpFormCrating = this.formCratingBatch.value.stampCodeList.map(
        (gg) => {
          return {
            prefix: gg.prefix.trim(),
            serialFirst: gg.serialFirst.trim(),
            serialLast: gg.serialLast.trim(),
          };
        }
      );
      data = tmpFormCrating.concat(this.stampList);
    }

    if (
      this.formCratingBatch.value.stampCodeList.length > 0 &&
      this.stampList.length === 0
    ) {
      data = this.formCratingBatch.value.stampCodeList.map((gg) => {
        return {
          prefix: gg.prefix.trim(),
          serialFirst: gg.serialFirst.trim(),
          serialLast: gg.serialLast.trim(),
        };
      });
    }

    if (
      this.formCratingBatch.value.stampCodeList.length === 0 &&
      this.stampList.length > 0
    ) {
      data = this.stampList;
    }

    if (data.length > 0) {
      // validateAPI
      console.log('data4', data)

      const convertValidate = [...data];
      const validateAPI = [];
      convertValidate.map((res) => {
        if (res.serialFirst && res.serialLast && res.serialFirst !== 'NaN' && res.serialLast !== 'NaN') {
          if (res.prefix.trim() !== '' &&
            res.serialFirst.trim() !== '' &&
            res.serialLast.trim() !== '') {
            validateAPI.push({
              prefix: res.prefix.toUpperCase(),
              idStart: res.serialFirst.toString(),
              idEnd: res.serialLast.toString(),
            });
          }
        }
      });
      console.log('validateAPI', validateAPI)
      this.groupItems = validateAPI;
      const body = {
        routing: this.formCratingBatch.value.is_routing,
        group: {
          items: validateAPI,
        },
        type:
          this.formCratingBatch.value.is_cratingStamps === 'cratingStampsSingle' ? 0 : 1,
      };
      if (this.groupItems.length === 0) {
        this.errorMessage = ['Stop...'];
        return
      }
      console.log('body', body)
      // @ts-ignore
      this.boxStampDistributionService.transferValidate(body).subscribe(
        (res) => {
          const errorMess = [];
          let allItem = [];
          if (res.code === 1) {
            allItem = res.data.items.map((val) => {
              val.listParent.map((pa) => {
                pa.child = {
                  idStart: val.idStart,
                  idEnd: val.idEnd,
                  prefix: val.prefix,
                };
                return pa;
              });
              return val;
            });
            if (allItem.length == res.data.totalElement) {
              allItem.map((val) => {
                if (val.errorMessage !== null) {
                  let mess = '';
                  if (val.idStart === val.idEnd) {
                    mess =
                      this.formatSerial(val.idStart, val.prefix.toUpperCase()) +
                      ' : ' +
                      val.errorMessage;
                  } else {
                    mess =
                      this.formatSerial(val.idStart, val.prefix.toUpperCase()) +
                      ' -> ' +
                      this.formatSerial(val.idEnd, val.prefix.toUpperCase()) +
                      ' : ' +
                      val.errorMessage;
                  }
                  errorMess.push(mess);
                }

                // check tem cha - con trùng nhau
                const excludeArray = res.data.items.filter(
                  (gg) => gg.prefix != val.prefix || gg.idStart != val.idStart
                );
                const listParent = excludeArray.reduce(
                  (r, a) => r.concat(a.listParent),
                  []
                );
                if (listParent) {
                  const isExistedItem = listParent.find(
                    (pa) =>
                      pa.prefix == val.prefix &&
                      (pa.number == val.idStart || pa.number == val.idEnd)
                  );
                  const insideExistedItem = listParent.find(
                    (pa) =>
                      pa.prefix == val.prefix &&
                      pa.number > val.idStart &&
                      pa.number < val.idEnd
                  );
                  if (isExistedItem) {
                    if (isExistedItem.child) {
                      // tem lẻ có cha là tem lẻ khác trong list tem lẻ gửi lên
                      if (
                        isExistedItem.child.idStart == isExistedItem.child.idEnd
                      ) {
                        const mess =
                          this.formatSerial(
                            val.idStart,
                            val.prefix.toUpperCase()
                          ) +
                          ' : ' + this.translateService.instant('LA_TEM_THUNG_CHA_CUA_TEM') +
                          this.formatSerial(
                            isExistedItem.child.idStart,
                            isExistedItem.child.prefix.toUpperCase()
                          );
                        errorMess.push(mess);
                      }
                      // dải tem có cha là đầu/cuối của dải tem khác
                      // tslint:disable-next-line:one-line
                      else {
                        const mess =
                          this.formatSerial(
                            val.idStart,
                            val.prefix.toUpperCase()
                          ) +
                          ' : ' + this.translateService.instant('LA_TEM_CHA_CUA_DAI_TEM') +
                          this.formatSerial(
                            isExistedItem.child.idStart,
                            isExistedItem.child.prefix.toUpperCase()
                          ) +
                          ' -> ' +
                          this.formatSerial(
                            isExistedItem.child.idEnd,
                            isExistedItem.child.prefix.toUpperCase()
                          );
                        errorMess.push(mess);
                      }
                    }
                  }
                  // tem thùng lẻ / dải tem có cha trong dải tem
                  if (insideExistedItem) {
                    if (insideExistedItem.child) {
                      if (
                        insideExistedItem.child.idStart ==
                        insideExistedItem.child.idEnd
                      ) {
                        const mess =
                          this.translateService.instant('TEM') + ' ' +
                          this.formatSerial(
                            insideExistedItem.child.idStart,
                            insideExistedItem.child.prefix
                          ) +
                          this.translateService.instant('CO_TEM_THUNG_CHA') +
                          this.formatSerial(
                            insideExistedItem.number,
                            insideExistedItem.prefix
                          ) +
                          this.translateService.instant('NAM_TRONG_DAI_TEM') +
                          this.formatSerial(val.idStart, val.prefix) +
                          ' -> ' +
                          this.formatSerial(val.idEnd, val.prefix);

                        errorMess.push(mess);
                      } else {
                        const mess =
                          this.translateService.instant('DAI_TEM') + ' ' +
                          this.formatSerial(
                            insideExistedItem.child.idStart,
                            insideExistedItem.child.prefix
                          ) +
                          ' -> ' +
                          this.formatSerial(
                            insideExistedItem.child.idEnd,
                            insideExistedItem.child.prefix
                          ) +
                          this.translateService.instant('CO_TEM_THUNG_CHA') +
                          this.formatSerial(
                            insideExistedItem.number,
                            insideExistedItem.prefix
                          ) +
                          this.translateService.instant('NAM_TRONG_DAI_TEM') +
                          this.formatSerial(val.idStart, val.prefix) +
                          ' -> ' +
                          this.formatSerial(val.idEnd, val.prefix);

                        errorMess.push(mess);
                      }
                    }
                  }
                }
              });
              if (errorMess.length > 0) {
                this.errorMessage = errorMess;
                // this.boxRetalStamps.errorMes(this.errorMessage);
                console.log(this.errorMessage)
              } else {
                this.errorMessage = [];
              }
            }
          } else {
            this.errorMessage = [res.message];
          }
        },
        (err) => {
          this.errorMessage = err.message
            ? [err.message]
            : ['Kiểm tra tem bị lỗi'];
        }
      );
      // end validateAPI
    } else {
      this.errorMessage = [];
      // this.waringListContent = '';
    }
  }

  clearErrorStamp() {
    this.errorCodeListStamp = [];
    this.errorListStamp = [];
    this.successCodeListStamp = [];
    this.successListStamp = [];
  }

  openModalClearStamp(type, typeStampModal) {
    console.log('đâsdasdasd', this.activeTab)
    this.typeStampModal = type
    if (typeStampModal == 'error') {
      this.typeStampModalString = 'tem lỗi'
      this.msgStampModal = typeStampModal
    } else {
      this.typeStampModalString = 'tem hợp lệ'
      this.msgStampModal = typeStampModal
    }
    console.log('this.typeStampModal', this.typeStampModal, this.typeStampModalString, this.msgStampModal)
    $('#clearAllStamp').modal('show');
  }

  hideModalClearStamp() {
    this.typeStampModal = ''
    this.typeStampModalString = ''
    this.msgStampModal = ''
    $('#clearAllStamp').modal('hide');
  }

  removeAllSuccessStamp(typeStamp) {
    if (typeStamp == 'singleStamp') {
      const arrStampSucces = this.successListStamp;
      arrStampSucces.map((item) => {
        this.stampList.map((val, index) => {
          if (val.prefix == item.prefix && val.serialFirst == item.idStart && val.serialLast == item.idEnd) {
            this.stampList.splice(index, 1);
          }
        })
      })
      this.successListStamp = []
    } else {
      console.log('Xoa tât ca em lem thành công ban đầu', this.stampListCodeList, this.successCodeListStamp)
      const arrStampSucces = this.successCodeListStamp;
      arrStampSucces.map((item) => {
        this.stampListCodeList.map((val, index) => {
          if (val.prefix == item.prefix && val.serialFirst == item.idStart && val.serialLast == item.idEnd) {
            this.stampListCodeList.splice(index, 1);
            console.log('Xoa tât ca em lem thành công ban đầu', this.stampListCodeList)
          }
        })
      })
      console.log('tem sau khi xóa thành công', this.stampListCodeList)
      this.successCodeListStamp = []
    }
    this.hideModalClearStamp()
  }

  removeAllErrorStampList(typeStamp) {
    if (typeStamp == 'singleStamp') {
      console.log(12312323345)
      const arrStampError = this.errorListStamp;
      arrStampError.map((item) => {
        this.stampList.map((val, index) => {
          if (val.prefix == item.prefix && val.serialFirst == item.idStart && val.serialLast == item.idEnd) {
            this.stampList.splice(index, 1);
          }
        })
      })
      this.errorListStamp = []
    } else {
      const arrStampError = this.errorCodeListStamp;
      arrStampError.map((item) => {
        this.stampListCodeList.map((val, index) => {
          if (val.prefix == item.prefix && val.serialFirst == item.idStart && val.serialLast == item.idEnd) {
            this.stampListCodeList.splice(index, 1);
          }
        })
      })
      this.errorCodeListStamp = []
    }
    this.hideModalClearStamp()
  }


  removeSuccessListStampSingle(i) {
    const arrStampSuccess = this.successListStamp[i];
    console.log('this.stamplist2', this.stampList, this.successListStamp)
    const index = this.stampList.findIndex((item) => {
      // tslint:disable-next-line:max-line-length
      return item.prefix == arrStampSuccess.prefix && item.serialFirst == arrStampSuccess.idStart && item.serialFirst == arrStampSuccess.idEnd
    })
    this.stampList.splice(index, 1);
    this.successListStamp = this.successListStamp.filter((res, k) => i !== k);
    console.log('this.stamplist1', this.stampList, this.successListStamp)

    // Đồng bộ xóa tem trong successInternalCodes tương ứng (nếu có)
    const internalCodeForItem = (arrStampSuccess as any).__internalCode;
    if (internalCodeForItem && this.successInternalCodes && this.successInternalCodes.length > 0) {
      this.successInternalCodes = this.successInternalCodes.filter(
        (code) => code !== internalCodeForItem
      );
    }
  }

  removeErrorListStampSingle(i) {
    const arrStampError = this.errorListStamp[i];
    console.log('this.stamplist222', this.stampList, this.errorListStamp)
    const index = this.stampList.findIndex((item) => {
      return item.prefix == arrStampError.prefix && item.serialFirst == arrStampError.idStart && item.serialFirst == arrStampError.idEnd
    })
    this.stampList.splice(index, 1);
    this.errorListStamp = this.errorListStamp.filter((res, k) => i !== k);
    console.log('this.stamplist', this.stampList, this.errorListStamp)
  }

  removeErrorCodeListStamp(i) {
    const arrStampError = this.errorCodeListStamp[i];
    console.log('this.stamplist222code', this.stampListCodeList, this.errorCodeListStamp)
    const index = this.stampListCodeList.findIndex((item) => {
      return item.prefix == arrStampError.prefix && item.serialFirst == arrStampError.idStart && item.serialFirst == arrStampError.idEnd
    })
    this.stampListCodeList.splice(index, 1);
    this.errorCodeListStamp = this.errorCodeListStamp.filter((res, k) => i !== k);
    console.log('this.stamplist222code', this.stampListCodeList, this.errorCodeListStamp)
  }

  removeSuccessCodeListStamp(i) {
    const arrStampSuccess = this.successCodeListStamp[i];
    console.log('this.stamplistcodesucceesss', this.stampListCodeList, this.successCodeListStamp, arrStampSuccess)
    const index = this.stampListCodeList.findIndex((item) => {
      // tslint:disable-next-line:max-line-length
      return item.prefix == arrStampSuccess.prefix && item.serialFirst == arrStampSuccess.idStart && item.serialFirst == arrStampSuccess.idEnd
    })
    this.stampListCodeList.splice(index, 1);
    this.successCodeListStamp = this.successCodeListStamp.filter((res, k) => i !== k);
    console.log('this.stamplistcodesucceesss', this.stampListCodeList, this.successCodeListStamp)
  }

  changeTypeDistribution(param) {
    this.formCratingBatch.value.is_routingTypeDistribution = param;
    if (this.formCratingBatch.value.is_routingTypeDistribution == 'notRouting') {
      this.isCheckRouting = false
    } else {
      this.isCheckRouting = true
    }
  }

  changeTypeDistributionImport(param) {
    this.formCratingBatch.value.is_routingImportTypeDistribution = param;
    if (this.formCratingBatch.value.is_routingImportTypeDistribution == 'noRoutingImport') {
      this.isCheckRoutingImport = false
      this.formCratingBatch.get('is_request_import').setValue(false);
    } else {
      this.isCheckRoutingImport = true
      this.formCratingBatch.get('is_request_import').setValue(true);
    }
  }

  keyPressAlphaNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-Z]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  hideModalWarningStamp() {
    $('#warningStamp').modal('hide');
  }

  getTypeDistribution() {
    console.log(' this.isCheckRouting', this.isCheckRouting, this.activeTab)
    this.boxStampDistributionService.getTypeSettingDistribute().subscribe((res) => {
      if (res.code == 1) {
        this.max_quantity = res.data.max_quantity;
        // transfer_type --- 0: không định tuyến -- 1: định tuyến
        // transfer_verify_type --- 0: có yêu cầu -- 1: không yêu cầu
        console.log('res.data', res.data)
        if (res.data.transfer_type == 1 || res.data.transfer_type == null) {
          this.isCheckRouting = true
          this.isCheckRoutingImport = true
          if (res.data.transfer_verify_type == 0 || res.data.transfer_verify_type == null) {
            this.formCratingBatch.get('is_routingTypeDistribution').setValue('routing2')
            this.formCratingBatch.get('is_routingImportTypeDistribution').setValue('routingImport')
            this.formCratingBatch.get('is_request').setValue(true);
            this.formCratingBatch.get('is_request_import').setValue(true);
            console.log(this.formCratingBatch.get('is_request'))
          } else {
            this.formCratingBatch.get('is_routingTypeDistribution').setValue('routing2')
            this.formCratingBatch.get('is_routingImportTypeDistribution').setValue('routingImport')
            this.formCratingBatch.get('is_request').setValue(false)
            this.formCratingBatch.get('is_request_import').setValue(true);
          }
        } else {
          this.formCratingBatch.get('is_routingTypeDistribution').setValue('noRouting')
          this.formCratingBatch.get('is_routingImportTypeDistribution').setValue('noRoutingImport')
          this.isCheckRouting = false;
          this.isCheckRoutingImport = false;
        }
      }
    })
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/share/boxStampDistribution/boxStampDistribution.component.ts